/*
Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
(window.theme = window.theme || {}),
  console &&
    console.log &&
    console.log(
      "Impulse theme (" +
        theme.settings.themeVersion +
        ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
    ),
  (window.lazySizesConfig = window.lazySizesConfig || {}),
  (lazySizesConfig.expFactor = 4),
  (function (e) {
    function t() {
      var t,
        i,
        n = e.Deferred();
      return (
        (t = setInterval(function () {
          Vimeo && (clearInterval(t), clearTimeout(i), n.resolve());
        }, 500)),
        (i = setTimeout(function () {
          clearInterval(t), n.reject();
        }, 4e3)),
        n
      );
    }
    var e = (jQuery = e);
    (theme.utils = {
      defaultTo: function (e, t) {
        return null == e || e !== e ? t : e;
      },
    }),
      (theme.a11y = {
        trapFocus: function (t) {
          function i(e) {
            9 === e.keyCode &&
              (e.target !== s || e.shiftKey || (e.preventDefault(), a.focus()),
              e.target === a && e.shiftKey && (e.preventDefault(), s.focus()));
          }
          var n = {
              focusin: t.namespace ? "focusin." + t.namespace : "focusin",
              focusout: t.namespace ? "focusout." + t.namespace : "focusout",
              keydown: t.namespace
                ? "keydown." + t.namespace
                : "keydown.handleFocus",
            },
            o = t.$container.find(
              e(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
              ).filter(":visible")
            ),
            a = o[0],
            s = o[o.length - 1];
          t.$elementToFocus || (t.$elementToFocus = t.$container),
            t.$container.attr("tabindex", "-1"),
            t.$elementToFocus.focus(),
            e(document).off("focusin"),
            e(document).on(n.focusout, function () {
              e(document).off(n.keydown);
            }),
            e(document).on(n.focusin, function (t) {
              (t.target !== s && t.target !== a) ||
                e(document).on(n.keydown, function (e) {
                  i(e);
                });
            });
        },
        removeTrapFocus: function (t) {
          var i = t.namespace ? "focusin." + t.namespace : "focusin";
          t.$container &&
            t.$container.length &&
            t.$container.removeAttr("tabindex"),
            e(document).off(i);
        },
        lockMobileScrolling: function (t, i) {
          if (i) var n = i;
          else var n = e(document.documentElement).add("body");
          n.on("touchmove" + t, function () {
            return !1;
          });
        },
        unlockMobileScrolling: function (t, i) {
          if (i) var n = i;
          else var n = e(document.documentElement).add("body");
          n.off(t);
        },
      }),
      (theme.Sections = function () {
        (this.constructors = {}),
          (this.instances = []),
          e(document)
            .on("shopify:section:load", this._onSectionLoad.bind(this))
            .on("shopify:section:unload", this._onSectionUnload.bind(this))
            .on("shopify:section:select", this._onSelect.bind(this))
            .on("shopify:section:deselect", this._onDeselect.bind(this))
            .on("shopify:block:select", this._onBlockSelect.bind(this))
            .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
      }),
      (theme.Sections.prototype = e.extend({}, theme.Sections.prototype, {
        createInstance: function (t, i, n) {
          var o = e(t),
            a = o.attr("data-section-id"),
            s = o.attr("data-section-type");
          if (((i = i || this.constructors[s]), "undefined" != typeof i)) {
            if (n) {
              var r = this._findInstance(a);
              if (r) return;
            }
            var c = e.extend(new i(t), { id: a, type: s, container: t });
            this.instances.push(c);
          }
        },
        _onSectionLoad: function (t, i, n) {
          AOS && AOS.refreshHard();
          var o = i ? i : e("[data-section-id]", t.target)[0];
          if (o) {
            this.createInstance(o);
            var a = i ? n : this._findInstance(t.detail.sectionId);
            i || this._loadSubSections(),
              a && "function" == typeof a.onLoad && a.onLoad(t);
          }
        },
        _loadSubSections: function () {
          AOS && AOS.refreshHard(),
            e("[data-subsection]").each(
              function (t, i) {
                this._onSectionLoad(null, i, e(i).data("section-id"));
              }.bind(this)
            );
        },
        _onSectionUnload: function (e) {
          var t = this._removeInstance(e.detail.sectionId);
          t && "function" == typeof t.onUnload && t.onUnload(e);
        },
        _onSelect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          t && "function" == typeof t.onSelect && t.onSelect(e);
        },
        _onDeselect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          t && "function" == typeof t.onDeselect && t.onDeselect(e);
        },
        _onBlockSelect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        },
        _findInstance: function (e) {
          for (var t = 0; t < this.instances.length; t++)
            if (this.instances[t].id === e) return this.instances[t];
        },
        _removeInstance: function (e) {
          for (var t, i = this.instances.length; i--; )
            if (this.instances[i].id === e) {
              (t = this.instances[i]), this.instances.splice(i, 1);
              break;
            }
          return t;
        },
        register: function (t, i, n) {
          this.constructors[t] = i;
          var o = e("[data-section-type=" + t + "]");
          n && (o = e("[data-section-type=" + t + "]", n)),
            o.each(
              function (e, t) {
                this.createInstance(t, i, n);
              }.bind(this)
            );
        },
      })),
      (theme.Currency = (function () {
        function e(e, t) {
          function n(e, t, i, n) {
            if (
              ((t = theme.utils.defaultTo(t, 2)),
              (i = theme.utils.defaultTo(i, ",")),
              (n = theme.utils.defaultTo(n, ".")),
              isNaN(e) || null == e)
            )
              return 0;
            e = (e / 100).toFixed(t);
            var o = e.split("."),
              a = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
              s = o[1] ? n + o[1] : "";
            return a + s;
          }
          t || (t = theme.settings.moneyFormat),
            "string" == typeof e && (e = e.replace(".", ""));
          var o = "",
            a = /\{\{\s*(\w+)\s*\}\}/,
            s = t || i;
          switch (s.match(a)[1]) {
            case "amount":
              o = n(e, 2);
              break;
            case "amount_no_decimals":
              o = n(e, 0);
              break;
            case "amount_with_comma_separator":
              o = n(e, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              o = n(e, 0, ".", ",");
              break;
            case "amount_no_decimals_with_space_separator":
              o = n(e, 0, " ");
          }
          return s.replace(a, o);
        }
        function t(e) {
          if (
            e &&
            e.unit_price_measurement &&
            e.unit_price_measurement.reference_value
          )
            return 1 === e.unit_price_measurement.reference_value
              ? e.unit_price_measurement.reference_unit
              : e.unit_price_measurement.reference_value +
                  e.unit_price_measurement.reference_unit;
        }
        var i = "${{amount}}";
        return { formatMoney: e, getBaseUnit: t };
      })()),
      (theme.Images = (function () {
        function e(e) {
          if (!e) return "620x";
          var t = e.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return null !== t ? t[1] : null;
        }
        function t(e, t) {
          if (!e) return e;
          if (null == t) return e;
          if ("master" === t) return this.removeProtocol(e);
          var i = e.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (null != i) {
            var n = e.split(i[0]),
              o = i[0];
            return this.removeProtocol(n[0] + "_" + t + o);
          }
          return null;
        }
        function i(e) {
          return e.replace(/http(s)?:/, "");
        }
        function n(e) {
          var t;
          return null !== e && (t = e.replace(/(\.[^.]*)$/, "_{width}x$1")), t;
        }
        return {
          imageSize: e,
          getSizedImageUrl: t,
          removeProtocol: i,
          lazyloadImagePath: n,
        };
      })()),
      (theme.Variants = (function () {
        function t(t) {
          (this.$container = t.$container),
            (this.variants = t.variants),
            (this.singleOptionSelector = t.singleOptionSelector),
            (this.originalSelectorId = t.originalSelectorId),
            (this.enableHistoryState = t.enableHistoryState),
            (this.currentVariant = this._getVariantFromOptions()),
            e(this.singleOptionSelector, this.$container).on(
              "change",
              this._onSelectChange.bind(this)
            );
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            _getCurrentOptions: function () {
              var t = e.map(
                e(this.singleOptionSelector, this.$container),
                function (t) {
                  var i = e(t),
                    n = i.attr("type"),
                    o = {};
                  return "radio" === n || "checkbox" === n
                    ? !!i[0].checked &&
                        ((o.value = i.val()), (o.index = i.data("index")), o)
                    : ((o.value = i.val()), (o.index = i.data("index")), o);
                }
              );
              return (t = this._compact(t));
            },
            _getVariantFromOptions: function () {
              var e = this._getCurrentOptions(),
                t = this.variants,
                i = !1;
              return (
                t.forEach(function (t) {
                  var n = !0;
                  t.options;
                  e.forEach(function (e) {
                    n && (n = t[e.index] === e.value);
                  }),
                    n && (i = t);
                }),
                i || null
              );
            },
            _onSelectChange: function () {
              var e = this._getVariantFromOptions();
              this.$container.trigger({ type: "variantChange", variant: e }),
                e &&
                  (this._updateMasterSelect(e),
                  this._updateImages(e),
                  this._updatePrice(e),
                  this._updateUnitPrice(e),
                  this._updateSKU(e),
                  (this.currentVariant = e),
                  this.enableHistoryState && this._updateHistoryState(e));
            },
            _updateImages: function (e) {
              var t = e.featured_image || {},
                i = this.currentVariant.featured_image || {};
              e.featured_image &&
                t.src !== i.src &&
                this.$container.trigger({
                  type: "variantImageChange",
                  variant: e,
                });
            },
            _updatePrice: function (e) {
              (e.price === this.currentVariant.price &&
                e.compare_at_price === this.currentVariant.compare_at_price) ||
                this.$container.trigger({
                  type: "variantPriceChange",
                  variant: e,
                });
            },
            _updateUnitPrice: function (e) {
              e.unit_price !== this.currentVariant.unit_price &&
                this.$container.trigger({
                  type: "variantUnitPriceChange",
                  variant: e,
                });
            },
            _updateSKU: function (e) {
              e.sku !== this.currentVariant.sku &&
                this.$container.trigger({
                  type: "variantSKUChange",
                  variant: e,
                });
            },
            _updateHistoryState: function (e) {
              if (history.replaceState && e) {
                var t =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  window.location.pathname +
                  "?variant=" +
                  e.id;
                window.history.replaceState({ path: t }, "", t);
              }
            },
            _updateMasterSelect: function (t) {
              e(this.originalSelectorId, this.$container).val(t.id);
            },
            _compact: function (e) {
              for (
                var t = -1, i = null == e ? 0 : e.length, n = 0, o = [];
                ++t < i;

              ) {
                var a = e[t];
                a && (o[n++] = a);
              }
              return o;
            },
          })),
          t
        );
      })()),
      (theme.rte = {
        init: function () {
          theme.rte.wrapTable(), theme.rte.wrapVideo(), theme.rte.imageLinks();
        },
        wrapTable: function () {
          e(".rte table").wrap('<div class="table-wrapper"></div>');
        },
        wrapVideo: function () {
          var t = e(
              '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
            ),
            i = t.add("iframe#admin_bar_iframe");
          t.each(function () {
            e(this).parents(".video-wrapper").length ||
              e(this).wrap('<div class="video-wrapper"></div>');
          }),
            i.each(function () {
              this.src = this.src;
            });
        },
        imageLinks: function () {
          e(".rte a img").parent().addClass("rte__image");
        },
      }),
      (theme.LibraryLoader = (function () {
        function e(e, a) {
          var r = s[e];
          if (r && r.status !== o.requested) {
            if (((a = a || function () {}), r.status === o.loaded))
              return void a();
            r.status = o.requested;
            var c;
            switch (r.type) {
              case n.script:
                c = t(r, a);
                break;
              case n.link:
                c = i(r, a);
            }
            (c.id = r.tagId), (r.element = c);
            var d = document.getElementsByTagName(r.type)[0];
            d.parentNode.insertBefore(c, d);
          }
        }
        function t(e, t) {
          var i = document.createElement("script");
          return (
            (i.src = e.src),
            i.addEventListener("load", function () {
              (e.status = o.loaded), t();
            }),
            i
          );
        }
        function i(e, t) {
          var i = document.createElement("link");
          return (
            (i.href = e.src),
            (i.rel = "stylesheet"),
            (i.type = "text/css"),
            i.addEventListener("load", function () {
              (e.status = o.loaded), t();
            }),
            i
          );
        }
        var n = { link: "link", script: "script" },
          o = { requested: "requested", loaded: "loaded" },
          a = "https://cdn.shopify.com/shopifycloud/",
          s = {
            youtubeSdk: {
              tagId: "youtube-sdk",
              src: "https://www.youtube.com/iframe_api",
              type: n.script,
            },
            shopifyXr: {
              tagId: "shopify-model-viewer-xr",
              src: a + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
              type: n.script,
            },
            modelViewerUi: {
              tagId: "shopify-model-viewer-ui",
              src: a + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
              type: n.script,
            },
            modelViewerUiStyles: {
              tagId: "shopify-model-viewer-ui-styles",
              src: a + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
              type: n.link,
            },
          };
        return { load: e };
      })()),
      (theme.Modals = (function () {
        function t(t, i, n) {
          var o = {
            close: ".js-modal-close",
            open: ".js-modal-open-" + i,
            openClass: "modal--is-active",
            closingClass: "modal--is-closing",
            bodyOpenClass: "modal-open",
            bodyOpenSolidClass: "modal-open--solid",
            bodyClosingClass: "modal-closing",
            closeOffContentClick: !0,
          };
          return (
            (this.id = t),
            (this.$modal = e("#" + t)),
            !!this.$modal.length &&
              ((this.nodes = {
                $parent: e("html").add("body"),
                $modalContent: this.$modal.find(".modal__inner"),
              }),
              (this.config = e.extend(o, n)),
              (this.modalIsOpen = !1),
              (this.$focusOnOpen = this.config.focusOnOpen
                ? e(this.config.focusOnOpen)
                : this.$modal),
              (this.isSolid = this.config.solid),
              void this.init())
          );
        }
        return (
          (t.prototype.init = function () {
            var t = e(this.config.open);
            t.attr("aria-expanded", "false"),
              e(this.config.open).on("click", this.open.bind(this)),
              this.$modal
                .find(this.config.close)
                .on("click", this.close.bind(this)),
              e("body").on(
                "drawerOpen",
                function () {
                  this.close();
                }.bind(this)
              );
          }),
          (t.prototype.open = function (t) {
            var i = !1;
            this.modalIsOpen ||
              (t ? t.preventDefault() : (i = !0),
              t &&
                t.stopPropagation &&
                (t.stopPropagation(),
                (this.$activeSource = e(t.currentTarget).attr(
                  "aria-expanded",
                  "true"
                ))),
              this.modalIsOpen && !i && this.close(),
              this.$modal.prepareTransition().addClass(this.config.openClass),
              this.nodes.$parent.addClass(this.config.bodyOpenClass),
              this.isSolid &&
                this.nodes.$parent.addClass(this.config.bodyOpenSolidClass),
              (this.modalIsOpen = !0),
              theme.a11y.trapFocus({
                $container: this.$modal,
                $elementToFocus: this.$focusOnOpen,
                namespace: "modal_focus",
              }),
              e("body")
                .trigger("productModalOpen")
                .trigger("modalOpen." + this.id),
              this.bindEvents());
          }),
          (t.prototype.close = function () {
            this.modalIsOpen &&
              (e(document.activeElement).trigger("blur"),
              this.$modal
                .prepareTransition()
                .removeClass(this.config.openClass)
                .addClass(this.config.closingClass),
              this.nodes.$parent.removeClass(this.config.bodyOpenClass),
              this.nodes.$parent.addClass(this.config.bodyClosingClass),
              window.setTimeout(
                function () {
                  this.nodes.$parent.removeClass(this.config.bodyClosingClass),
                    this.$modal.removeClass(this.config.closingClass),
                    this.$activeSource &&
                      this.$activeSource.attr("aria-expanded") &&
                      this.$activeSource.attr("aria-expanded", "false").focus();
                }.bind(this),
                550
              ),
              this.isSolid &&
                this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass),
              (this.modalIsOpen = !1),
              theme.a11y.removeTrapFocus({
                $container: this.$modal,
                namespace: "modal_focus",
              }),
              e("body").trigger("modalClose." + this.id),
              this.unbindEvents());
          }),
          (t.prototype.bindEvents = function () {
            this.nodes.$parent.on(
              "keyup.modal",
              function (e) {
                27 === e.keyCode && this.close();
              }.bind(this)
            ),
              this.config.closeOffContentClick &&
                (this.$modal.on("click.modal", this.close.bind(this)),
                this.nodes.$modalContent.on("click.modal", function (e) {
                  e.stopImmediatePropagation();
                }));
          }),
          (t.prototype.unbindEvents = function () {
            this.nodes.$parent.off(".modal"),
              this.config.closeOffContentClick &&
                (this.$modal.off(".modal"),
                this.nodes.$modalContent.off(".modal"));
          }),
          t
        );
      })()),
      (theme.Drawers = (function () {
        function t(t, i, n) {
          return (
            (this.config = {
              id: t,
              close: ".js-drawer-close",
              open: ".js-drawer-open-" + i,
              openClass: "js-drawer-open",
              closingClass: "js-drawer-closing",
              activeDrawer: "drawer--is-open",
              namespace: ".drawer-" + i,
            }),
            (this.$nodes = {
              parent: e(document.documentElement).add("body"),
              page: e("#MainContent"),
            }),
            (this.$drawer = e("#" + t)),
            !!this.$drawer.length &&
              ((this.isOpen = !1),
              (this.ignoreScrollLock = n),
              void this.init())
          );
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              var t = e(this.config.open);
              t.attr("aria-expanded", "false"),
                t.on("click", this.open.bind(this)),
                this.$drawer
                  .find(this.config.close)
                  .on("click", this.close.bind(this)),
                e("body").on(
                  "productModalOpen",
                  function () {
                    this.close();
                  }.bind(this)
                );
            },
            open: function (t, i) {
              if ((t && t.preventDefault(), !this.isOpen)) {
                if (t && t.stopPropagation)
                  t.stopPropagation(),
                    (this.$activeSource = e(t.currentTarget).attr(
                      "aria-expanded",
                      "true"
                    ));
                else if (i) {
                  var n = e(i);
                  this.$activeSource = n.attr("aria-expanded", "true");
                }
                this.$drawer
                  .prepareTransition()
                  .addClass(this.config.activeDrawer),
                  this.$nodes.parent.addClass(this.config.openClass),
                  (this.isOpen = !0),
                  theme.a11y.trapFocus({
                    $container: this.$drawer,
                    namespace: "drawer_focus",
                  }),
                  e("body")
                    .trigger("drawerOpen")
                    .trigger("drawerOpen." + this.config.id),
                  this.bindEvents();
              }
            },
            close: function () {
              this.isOpen &&
                (e(document.activeElement).trigger("blur"),
                this.$drawer
                  .prepareTransition()
                  .removeClass(this.config.activeDrawer),
                this.$nodes.parent.removeClass(this.config.openClass),
                this.$nodes.parent.addClass(this.config.closingClass),
                window.setTimeout(
                  function () {
                    this.$nodes.parent.removeClass(this.config.closingClass),
                      this.$activeSource &&
                        this.$activeSource.attr("aria-expanded") &&
                        this.$activeSource
                          .attr("aria-expanded", "false")
                          .focus();
                  }.bind(this),
                  500
                ),
                (this.isOpen = !1),
                theme.a11y.removeTrapFocus({
                  $container: this.$drawer,
                  namespace: "drawer_focus",
                }),
                this.unbindEvents());
            },
            bindEvents: function () {
              this.ignoreScrollLock ||
                theme.a11y.lockMobileScrolling(
                  this.config.namespace,
                  this.$nodes.page
                ),
                this.$nodes.page.on(
                  "click" + this.config.namespace,
                  function (t) {
                    var i = e(t.target),
                      n = this.elementInsideDrawer(i);
                    if (!n) return this.close(), !1;
                  }.bind(this)
                ),
                this.$nodes.parent.on(
                  "keyup" + this.config.namespace,
                  function (e) {
                    27 === e.keyCode && this.close();
                  }.bind(this)
                );
            },
            unbindEvents: function () {
              this.ignoreScrollLock ||
                theme.a11y.unlockMobileScrolling(
                  this.config.namespace,
                  this.$nodes.page
                ),
                this.$nodes.parent.off(this.config.namespace),
                this.$nodes.page.off(this.config.namespace);
            },
            elementInsideDrawer: function (e) {
              return this.$drawer.find(e).length;
            },
          })),
          t
        );
      })()),
      (theme.cart = {
        getCart: function () {
          return e.getJSON(theme.routes.cart);
        },
        changeItem: function (e, t) {
          return this._updateCart({
            type: "POST",
            url: theme.routes.cartChange,
            data: "quantity=" + t + "&id=" + e,
            dataType: "json",
          });
        },
        addItemFromForm: function (e) {
          return this._updateCart({
            type: "POST",
            url: theme.routes.cartAdd,
            data: e,
            dataType: "json",
          });
        },
        _updateCart: function (t) {
          return e.ajax(t).then(
            function (e) {
              return e;
            }.bind(this)
          );
        },
        updateNote: function (t) {
          var i = {
            type: "POST",
            url: "/cart/update.js",
            data: "note=" + theme.cart.attributeToString(t),
            dataType: "json",
            success: function (e) {},
            error: function (e, t) {},
          };
          e.ajax(i);
        },
        attributeToString: function (e) {
          return (
            "string" != typeof e && ((e += ""), "undefined" === e && (e = "")),
            e.trim()
          );
        },
      }),
      e(function () {
        e("body").on("click", ".cart__checkout", function () {
          e(this).addClass("btn--loading");
        }),
          e("body").on("change", 'textarea[name="note"]', function () {
            var t = e(this).val();
            theme.cart.updateNote(t);
          }),
          e("body").on("click", ".cart__checkout--ajax", function (t) {
            if (!e("#CartAgree").is(":checked"))
              return (
                alert(theme.strings.cartTermsConfirmation),
                e(this).removeClass("btn--loading"),
                !1
              );
          }),
          e("body").on("click", ".cart__checkout--page", function (t) {
            if (!e("#CartPageAgree").is(":checked"))
              return (
                alert(theme.strings.cartTermsConfirmation),
                e(this).removeClass("btn--loading"),
                !1
              );
          });
      }),
      (theme.QtySelector = (function () {
        function t(t, n) {
          (this.$wrapper = t),
            (this.$input = t.find(i.input)),
            (this.$plus = t.find(i.plus)),
            (this.$minus = t.find(i.minus)),
            (this.minValue = this.$input.attr("min") || 1);
          var o = { namespace: null, key: this.$input.data("id") };
          (this.options = e.extend(o, n)), this.initEventListeners();
        }
        var i = {
          input: ".js-qty__num",
          plus: ".js-qty__adjust--plus",
          minus: ".js-qty__adjust--minus",
        };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            initEventListeners: function () {
              this.$plus.on(
                "click",
                function () {
                  var e = this.validateQty(this.$input.val());
                  this.addQty(e);
                }.bind(this)
              ),
                this.$minus.on(
                  "click",
                  function () {
                    var e = this.validateQty(this.$input.val());
                    this.subtractQty(e);
                  }.bind(this)
                ),
                this.$input.on(
                  "change",
                  function () {
                    var e = this.validateQty(this.$input.val());
                    this.changeQty(e);
                  }.bind(this)
                );
            },
            addQty: function (e) {
              var t = e + 1;
              this.changeQty(t);
            },
            subtractQty: function (e) {
              var t = e - 1;
              t <= this.minValue && (t = this.minValue), this.changeQty(t);
            },
            changeQty: function (t) {
              this.$input.val(t),
                e("body").trigger("qty" + this.options.namespace, [
                  this.options.key,
                  t,
                ]);
            },
            validateQty: function (e) {
              return (
                (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1),
                parseInt(e)
              );
            },
          })),
          t
        );
      })()),
      (theme.CartDrawer = (function () {
        function t() {
          (this.status = { loaded: !1, loading: !1 }),
            (this.drawer = new theme.Drawers("CartDrawer", "cart"));
          var t = e(n.template).html();
          (this.template = Handlebars.compile(t)),
            theme.cart.getCart().then(this.buildCart.bind(this)),
            this.initEventListeners();
        }
        var i = { namespace: ".ajaxcart" },
          n = {
            drawer: "#CartDrawer",
            container: "#CartContainer",
            template: "#CartTemplate",
            cartBubble: ".cart-link__bubble",
          };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            initEventListeners: function () {
              e("body").on(
                "updateCart" + i.namespace,
                this.initQtySelectors.bind(this)
              ),
                e("body").on(
                  "updateCart" + i.namespace,
                  this.updateCartNotification.bind(this)
                ),
                e("body").on(
                  "added.ajaxProduct",
                  function (e, t) {
                    theme.cart.getCart().then(
                      function (e) {
                        this.buildCart(e, !0, t);
                      }.bind(this)
                    );
                  }.bind(this)
                );
            },
            buildCart: function (t, o, a) {
              if ((this.loading(!0), this.emptyCart(), 0 === t.item_count))
                e(n.container).append(
                  '<div class="drawer__scrollable"><p class="appear-animation appear-delay-3">' +
                    theme.strings.cartEmpty +
                    "</p></div>"
                );
              else {
                var s = [],
                  r = {},
                  c = {},
                  d = 1;
                e.each(t.items, function (t, i) {
                  var n;
                  (n =
                    null !== i.image
                      ? i.image.replace(/(\.[^.]*)$/, "_180x$1")
                      : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif"),
                    null !== i.properties &&
                      e.each(i.properties, function (e, t) {
                        ("_" !== e.charAt(0) && t) || delete i.properties[e];
                      });
                  var o = 0;
                  if (0 !== i.line_level_discount_allocations.length)
                    for (var a in i.line_level_discount_allocations)
                      (o = i.line_level_discount_allocations[a].amount),
                        (i.line_level_discount_allocations[a].formattedAmount =
                          theme.Currency.formatMoney(
                            o,
                            theme.settings.moneyFormat
                          ));
                  (d += 2),
                    (r = {
                      key: i.key,
                      url: i.url,
                      img: n,
                      animationRow: d,
                      name: i.product_title,
                      variation: i.variant_title,
                      properties: i.properties,
                      itemQty: i.quantity,
                      price: theme.Currency.formatMoney(
                        i.price,
                        theme.settings.moneyFormat
                      ),
                      unitPrice: theme.Currency.formatMoney(
                        i.unit_price,
                        theme.settings.moneyFormat
                      ),
                      unitBase: theme.Currency.getBaseUnit(i),
                      discountedPrice: theme.Currency.formatMoney(
                        i.price - i.total_discount / i.quantity,
                        theme.settings.moneyFormat
                      ),
                      discounts: i.line_level_discount_allocations,
                      discountsApplied:
                        0 !== i.line_level_discount_allocations.length,
                      vendor: i.vendor,
                    }),
                    s.push(r);
                }),
                  (d += 2);
                var l = 0;
                if (0 !== t.cart_level_discount_applications.length)
                  for (var h in t.cart_level_discount_applications)
                    (l =
                      t.cart_level_discount_applications[h]
                        .total_allocated_amount),
                      (t.cart_level_discount_applications[h].formattedAmount =
                        theme.Currency.formatMoney(
                          l,
                          theme.settings.moneyFormat
                        ));
                (c = {
                  items: s,
                  note: t.note,
                  lastAnimationRow: d,
                  cartDiscounts: t.cart_level_discount_applications,
                  cartDiscountsApplied:
                    0 !== t.cart_level_discount_applications.length,
                  totalPrice: theme.Currency.formatMoney(
                    t.total_price,
                    theme.settings.moneyFormat
                  ),
                }),
                  e(n.container).append(this.template(c));
              }
              (this.status.loaded = !0),
                this.loading(!1),
                e("body").trigger("updateCart" + i.namespace, t),
                Shopify &&
                  Shopify.StorefrontExpressButtons &&
                  Shopify.StorefrontExpressButtons.initialize(),
                o === !0 && this.drawer.open(!1, a);
            },
            initQtySelectors: function () {
              e(n.container)
                .find(".js-qty__wrapper")
                .each(
                  function (t, i) {
                    new theme.QtySelector(e(i), { namespace: ".cart-drawer" });
                  }.bind(this)
                ),
                e("body").on("qty.cart-drawer", this.updateItem.bind(this));
            },
            updateItem: function (e, t, i) {
              this.status.loading ||
                (this.loading(!0),
                theme.cart
                  .changeItem(t, i)
                  .then(
                    function (e) {
                      this.updateSuccess(e);
                    }.bind(this)
                  )
                  .catch(
                    function (e) {
                      this.updateError(e);
                    }.bind(this)
                  )
                  .always(
                    function () {
                      this.loading(!1);
                    }.bind(this)
                  ));
            },
            loading: function (t) {
              (this.status.loading = t),
                t
                  ? e(n.container).addClass("is-loading")
                  : e(n.container).removeClass("is-loading");
            },
            emptyCart: function () {
              e(n.container).empty();
            },
            updateSuccess: function (e) {
              this.buildCart(e);
            },
            updateError: function (e) {
              e.responseJSON && e.responseJSON.description;
            },
            updateCartNotification: function (t, i) {
              i.items.length > 0
                ? e(n.cartBubble).addClass("cart-link__bubble--visible")
                : e(n.cartBubble).removeClass("cart-link__bubble--visible");
            },
          })),
          t
        );
      })()),
      (theme.AjaxProduct = (function () {
        function t(e) {
          (this.$form = e),
            (this.$addToCart = this.$form.find(".add-to-cart")),
            this.$form.length &&
              this.$form.on("submit", this.addItemFromForm.bind(this));
        }
        var i = { loading: !1 };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            addItemFromForm: function (e, t) {
              if ((e.preventDefault(), !i.loading)) {
                this.$addToCart.addClass("btn--loading"), (i.loading = !0);
                var n = this.$form.serialize();
                theme.cart
                  .addItemFromForm(n)
                  .then(
                    function (e) {
                      this.success(e);
                    }.bind(this)
                  )
                  .catch(
                    function (e) {
                      this.error(e);
                    }.bind(this)
                  )
                  .always(
                    function () {
                      (i.loading = !1),
                        this.$addToCart.removeClass("btn--loading");
                    }.bind(this)
                  );
              }
            },
            success: function (t) {
              this.$form.find(".errors").remove(),
                e("body").trigger("added.ajaxProduct", this.$addToCart);
            },
            error: function (e) {
              this.$form.find(".errors").remove(),
                e.responseJSON &&
                  e.responseJSON.description &&
                  this.$form.prepend(
                    '<div class="errors text-center">' +
                      e.responseJSON.description +
                      "</div>"
                  );
            },
          })),
          t
        );
      })()),
      (theme.collapsibles = (function () {
        function t() {
          e(n.trigger).each(function () {
            var t = e(this),
              i = t.hasClass(o.open);
            t.attr("aria-expanded", i);
          }),
            e("body, .modal__inner")
              .off(a)
              .on("click" + a, n.trigger, function () {
                if (!s) {
                  s = !0;
                  var t = e(this),
                    a = t.hasClass(o.open),
                    r = t.attr("aria-controls"),
                    c = e("#" + r),
                    d = c.find(n.moduleInner).outerHeight(),
                    l = t.hasClass(o.autoHeight);
                  a &&
                    l &&
                    setTimeout(function () {
                      (d = 0), i(c, d, a, l);
                    }, 0),
                    a && !l && (d = 0),
                    t.attr("aria-expanded", !a).toggleClass(o.open, !a),
                    i(c, d, a, l);
                }
              });
        }
        function i(e, t, i, n) {
          if (
            (e
              .removeClass(o.hide)
              .prepareTransition()
              .css("height", t)
              .toggleClass(o.open, !i),
            !i && n)
          ) {
            var a = e;
            window.setTimeout(function () {
              a.css("height", "auto"), (s = !1);
            }, 350);
          } else s = !1;
        }
        var n = {
            trigger: ".collapsible-trigger",
            module: ".collapsible-content",
            moduleInner: ".collapsible-content__inner",
          },
          o = {
            hide: "hide",
            open: "is-open",
            autoHeight: "collapsible--auto-height",
          },
          a = ".collapsible",
          s = !1;
        return { init: t };
      })()),
      (theme.headerNav = (function () {
        function t() {
          (p = e(window)),
            (m = e(S.navContainerWithLogo)),
            (f = e(S.logoContainer)),
            (g = e(S.navigation)),
            (v = e(S.wrapper)),
            (y = e(S.siteHeader)),
            (C.wrapperOverlayed = theme.settings.overlayHeader =
              v.hasClass(C.overlayedClass)),
            (C.stickyEnabled = y.data("sticky")),
            C.stickyEnabled &&
              (r(), p.on("resize" + C.namespace, e.debounce(150, r))),
            C.wrapperOverlayed && e("body").addClass(_.overlaidBodyClass),
            s(),
            n();
        }
        function i() {
          e(window).off(C.namespace),
            e(S.searchBtn).off(C.namespace),
            e(S.closeSearch).off(C.namespace),
            b.off(C.namespace),
            e(S.navLinks).off(C.namespace),
            e(S.navDropdownLinks).off(C.namespace);
        }
        function n() {
          e(S.searchBtn).on("click" + C.namespace, function (e) {
            e.preventDefault(), o();
          }),
            e(S.closeSearch).on("click" + C.namespace, function () {
              a();
            });
        }
        function o() {
          e(S.searchContainer).addClass("is-active"),
            b.addClass("js-drawer-open--search"),
            theme.a11y.trapFocus({
              $container: e(S.searchContainer),
              namespace: "header_search",
              $elementToFocus: e(S.searchContainer).find("input"),
            }),
            theme.config.bpSmall &&
              C.stickyEnabled &&
              C.lastScroll < 300 &&
              window.scrollTo(0, 0),
            theme.a11y.lockMobileScrolling(C.namespace),
            w.on("click" + C.namespace, function () {
              return a(), !1;
            }),
            b.on("keyup" + C.namespace, function (e) {
              27 === e.keyCode && a();
            });
        }
        function a() {
          e(document.activeElement).trigger("blur"),
            b.removeClass("js-drawer-open--search").off(C.namespace),
            e(S.searchContainer).removeClass("is-active"),
            theme.a11y.removeTrapFocus({
              $container: e(S.searchContainer),
              namespace: "header_search",
            }),
            theme.a11y.unlockMobileScrolling(C.namespace),
            w.off("click" + C.namespace),
            b.off("keyup" + C.namespace);
        }
        function s() {
          function t(t) {
            var i = t.parent();
            if (
              (i.hasClass(_.hasDropdownClass) &&
                (i.addClass(_.dropdownActive), (s = !0)),
              !theme.config.isTouch && !c)
            ) {
              var o = theme.config.isTouch ? "touchend" : "click";
              (c = !0),
                e("body").on(o + C.namespace, function () {
                  n(), e("body").off(C.namespace), (c = !1);
                });
            }
          }
          function i(e, t) {
            var i = e.parent();
            (i.hasClass(_.hasSubDropdownClass) || t) &&
              (i.addClass(_.dropdownActive), (r = !0));
          }
          function n() {
            o(), a();
          }
          function o() {
            e(S.navItems).removeClass(_.dropdownActive);
          }
          function a() {
            e(S.navDropdownLinks).parent().removeClass(_.dropdownActive);
          }
          var s = !1,
            r = !1,
            c = !1;
          theme.config.isTouch &&
            (e(S.navLinksWithDropdown).on(
              "touchend" + C.namespace,
              function (i) {
                var o = e(this),
                  a = o.parent();
                a.hasClass(_.dropdownActive)
                  ? window.location.replace(o.attr("href"))
                  : (i.preventDefault(), n(), t(o));
              }
            ),
            e(S.navDropdownLinks).on("touchend" + C.namespace, function (t) {
              var n = e(this),
                o = n.parent();
              o.hasClass(_.hasSubDropdownClass)
                ? o.hasClass(_.dropdownActive)
                  ? window.location.replace(n.attr("href"))
                  : (t.preventDefault(), a(), i(n))
                : window.location.replace(n.attr("href"));
            }),
            e("body").on("touchend" + C.namespace, function () {
              o(), a();
            }),
            e(S.megamenu).on("touchend" + C.namespace, function (e) {
              e.stopImmediatePropagation();
            })),
            e(S.navLinks).on("focusin mouseover" + C.namespace, function () {
              s && o(), r && a(), t(e(this));
            }),
            e(S.navLinks).on("mouseleave" + C.namespace, function () {
              o(), a();
            }),
            e(S.navDropdownLinks).on("focusin" + C.namespace, function () {
              r && a(), i(e(this), !0);
            });
        }
        function r() {
          (theme.config.stickyHeader = d()),
            theme.config.stickyHeader
              ? ((C.forceStopSticky = !1), c())
              : (C.forceStopSticky = !0);
        }
        function c() {
          C.stickyInitialized ||
            (b.addClass(_.stickyBodyClass),
            y.wrap('<div class="site-header-sticky"></div>'),
            l(),
            setTimeout(function () {
              l();
            }, 200),
            p.on("resize" + C.namespace, e.debounce(50, l)),
            p.on("scroll" + C.namespace, e.throttle(15, h))),
            (C.stickyInitialized = !0);
        }
        function d() {
          var t = 0;
          return (
            e(S.megamenu).each(function () {
              var i = e(this).outerHeight();
              i > t && (t = i);
            }),
            !(window.innerHeight < t + 120)
          );
        }
        function l() {
          var t = y.outerHeight(!0);
          e(".site-header-sticky").css("height", t);
          e(".grid__item--sidebar").length &&
            e(".grid__item--sidebar").css("top", t + 10);
        }
        function h() {
          if (!C.forceStopSticky) {
            var e = p.scrollTop(),
              t = 150;
            if (e > t) {
              if (C.stickyActive) return;
              (C.stickyActive = !0),
                y.addClass(C.stickyClass),
                C.wrapperOverlayed && v.removeClass(C.overlayedClass),
                setTimeout(function () {
                  y.addClass(C.openTransitionClass);
                }, 100);
            } else {
              if (!C.stickyActive) return;
              (C.stickyActive = !1),
                y.removeClass(C.openTransitionClass).removeClass(C.stickyClass),
                C.wrapperOverlayed && v.addClass(C.overlayedClass);
            }
            C.lastScroll = e;
          }
        }
        function u() {
          e(S.wrapper)
            .removeClass(C.stickyEnabledClass)
            .removeClass(C.overlayedClass),
            e("body").removeClass(_.overlaidBodyClass),
            (C.wrapperOverlayed = !1);
        }
        var p,
          m,
          f,
          g,
          v,
          y,
          b = e(document.documentElement).add("body"),
          w = e("#MainContent"),
          S = {
            wrapper: ".header-wrapper",
            siteHeader: ".site-header",
            searchBtn: ".js-search-header",
            closeSearch: ".js-search-header-close",
            searchContainer: ".site-header__search-container",
            logoContainer: ".site-header__logo",
            logo: ".site-header__logo img",
            navigation: ".site-navigation",
            megamenu: ".megamenu",
            navContainerWithLogo: ".header-item--logo",
            navItems: ".site-nav__item",
            navLinks: ".site-nav__link",
            navLinksWithDropdown: ".site-nav__link--has-dropdown",
            navDropdownLinks: ".site-nav__dropdown-link--second-level",
          },
          _ = {
            hasDropdownClass: "site-nav--has-dropdown",
            hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
            dropdownActive: "is-focused",
            overlaidBodyClass: "overlaid-header",
            stickyBodyClass: "sticky-header",
          },
          C = {
            namespace: ".siteNav",
            wrapperOverlayed: !1,
            overlayedClass: "is-light",
            stickyEnabledClass: "header-wrapper--sticky",
            stickyEnabled: !1,
            stickyActive: !1,
            stickyInitialized: !1,
            forceStopSticky: !1,
            stickyClass: "site-header--stuck",
            openTransitionClass: "site-header--opening",
            lastScroll: 0,
          };
        return { init: t, disableOverlayHeader: u, unload: i };
      })()),
      (theme.Slideshow = (function () {
        function t(t, n) {
          (this.$slideshow = e(t)),
            (this.$wrapper = this.$slideshow.closest("." + i.wrapper)),
            (this.$pause = this.$wrapper.find("." + i.pauseButton)),
            (this.settings = {
              accessibility: !0,
              arrows: !!n.arrows,
              dots: !!n.dots,
              fade: !!n.fade,
              speed: n.speed ? n.speed : 500,
              draggable: !0,
              touchThreshold: 5,
              pauseOnHover: !1,
              autoplay: !!n.autoplay,
              autoplaySpeed: this.$slideshow.data("speed"),
            }),
            this.$slideshow.off("beforeChange"),
            this.$slideshow.off("afterSlideChange"),
            this.$slideshow.on("init", this.init.bind(this)),
            this.$slideshow.on(
              "beforeChange",
              this.beforeSlideChange.bind(this)
            ),
            this.$slideshow.on("afterChange", this.afterSlideChange.bind(this)),
            this.$slideshow.slick(this.settings),
            this.$pause.on("click", this._togglePause.bind(this));
        }
        this.$slideshow = null;
        var i = {
          next: "is-next",
          init: "is-init",
          animateOut: "animate-out",
          wrapper: "slideshow-wrapper",
          slideshow: "slideshow",
          allSlides: "slick-slide",
          currentSlide: "slick-current",
          pauseButton: "slideshow__pause",
          isPaused: "is-paused",
        };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function (e, t) {
              (this.$slideshowList = t.$list),
                (this.$slickDots = t.$dots),
                (this.$allSlides = t.$slides),
                (this.slideCount = t.slideCount),
                this.$slideshow.addClass(i.init),
                this._a11y(),
                this._clonedLazyloading();
            },
            beforeSlideChange: function (e, t, n, o) {
              var a = t.$slider;
              a.find("." + i.currentSlide).addClass(i.animateOut);
            },
            afterSlideChange: function (e, t, n) {
              var o = t.$slider;
              o.find("." + i.allSlides).removeClass(i.animateOut);
            },
            destroy: function () {
              this.$slideshow.slick("unslick");
            },
            _play: function () {
              this.$slideshow.slick("slickPause"),
                e(i.pauseButton).addClass("is-paused");
            },
            _pause: function () {
              this.$slideshow.slick("slickPlay"),
                e(i.pauseButton).removeClass("is-paused");
            },
            _togglePause: function () {
              var t = this._getSlideshowId(this.$pause);
              this.$pause.hasClass(i.isPaused)
                ? (this.$pause.removeClass(i.isPaused), e(t).slick("slickPlay"))
                : (this.$pause.addClass(i.isPaused), e(t).slick("slickPause"));
            },
            _getSlideshowId: function (e) {
              return "#Slideshow-" + e.data("id");
            },
            _activeSlide: function () {
              return this.$slideshow.find(".slick-active");
            },
            _currentSlide: function () {
              return this.$slideshow.find(".slick-current");
            },
            _nextSlide: function (e) {
              return this.$slideshow.find(
                '.slideshow__slide[data-slick-index="' + e + '"]'
              );
            },
            _a11y: function () {
              var t = this.$slideshowList,
                n = this.settings.autoplay;
              t &&
                (t.removeAttr("aria-live"),
                e(i.wrapper).on(
                  "focusin",
                  function (o) {
                    e(i.wrapper).has(o.target).length &&
                      (t.attr("aria-live", "polite"), n && this._pause());
                  }.bind(this)
                ),
                e(i.wrapper).on(
                  "focusout",
                  function (o) {
                    e(i.wrapper).has(o.target).length &&
                      (t.removeAttr("aria-live"), n && this._play());
                  }.bind(this)
                ));
            },
            _clonedLazyloading: function () {
              var t = this.$slideshow;
              t.find(".slick-slide").each(
                function (i, n) {
                  var o = e(n);
                  if (o.hasClass("slick-cloned")) {
                    var a = o.data("id"),
                      s = o
                        .find(".hero__image")
                        .removeClass("lazyloading")
                        .addClass("lazyloaded");
                    setTimeout(function () {
                      var e = t
                        .find(
                          ".slideshow__slide--" +
                            a +
                            ":not(.slick-cloned) .hero__image"
                        )
                        .attr("style");
                      e && s.attr("style", e);
                    }, this.settings.autoplaySpeed / 1.5);
                  }
                }.bind(this)
              );
            },
          })),
          t
        );
      })()),
      (theme.announcementBar = (function () {
        function t() {
          if (((r = e("#AnnouncementSlider")), r.length)) {
            (c = r.data("block-count")), (d = r.data("compact-style"));
            var t = e.extend({}, l, {
                slidesToShow: d ? 1 : c,
                slidesToScroll: 1,
              }),
              n = e.extend({}, l, { slidesToShow: 1 });
            theme.config.bpSmall ? i(r, n) : i(r, t),
              e("body").on(
                "matchSmall",
                function () {
                  i(r, n);
                }.bind(this)
              ),
              e("body").on(
                "matchLarge",
                function () {
                  i(r, t);
                }.bind(this)
              );
          }
        }
        function i(e, t) {
          n(e) && e.slick("unslick"), e.slick(t);
        }
        function n(e) {
          return e.length && e.hasClass("slick-initialized");
        }
        function o(t) {
          var i = e("#AnnouncementSlide-" + t);
          r.length && r.slick("slickPause"),
            i.length && r.slick("slickGoTo", i.data("index"));
        }
        function a(e) {
          r.length && n(r) && r.slick("slickPlay");
        }
        function s() {
          n(r) && r.slick("unslick");
        }
        var r,
          c = 0,
          d = !1,
          l = {
            accessibility: !0,
            arrows: !1,
            dots: !1,
            autoplay: !0,
            autoplaySpeed: 5e3,
            touchThreshold: 20,
            slidesToShow: 1,
          };
        return { init: t, onBlockSelect: o, onBlockDeselect: a, unload: s };
      })()),
      (theme.predictiveSearch = (function () {
        function t() {
          if (document.getElementById("shopify-features")) {
            var t = JSON.parse(
              document.getElementById("shopify-features").innerHTML
            );
            if (!t.predictiveSearch) return;
          }
          e(y.form).attr("autocomplete", "off"),
            e(y.form).on("submit" + v, o),
            e(y.input, y.form).on("keyup" + v, a),
            e(y.searchButton, y.wrapper).on("click" + v, n);
          var i = e(y.resultTemplate).html();
          resultTemplate = Handlebars.compile(i);
        }
        function i() {
          e(y.wrapper).addClass("hide"), clearTimeout(m);
        }
        function n() {
          e(y.form).trigger("submit");
        }
        function o(t) {
          var i = e(this);
          t.preventDefault ? t.preventDefault() : (t.returnValue = !1);
          var n = i.serializeArray().reduce(function (e, t) {
            return (e[t.name] = t.value), e;
          }, {});
          n.q && (n.q += "*");
          var o = e.param(n);
          return (window.location.href = "/search?" + o), !1;
        }
        function a(e) {
          return e.keyCode === b.up_arrow
            ? void p(e, "up")
            : e.keyCode === b.down_arrow
            ? void p(e, "down")
            : void (e.keyCode !== b.tab && s());
        }
        function s() {
          var t = e(y.input, y.form).val();
          if ("" === t) return void i();
          var n = u(t);
          clearTimeout(m),
            (m = setTimeout(
              function () {
                r(n);
              }.bind(this),
              500
            ));
        }
        function r(t) {
          g ||
            (f !== t &&
              ((f = t),
              (g = !0),
              jQuery
                .getJSON("/search/suggest.json", {
                  q: t,
                  resources: {
                    type: theme.settings.predictiveSearchType,
                    limit: 4,
                    options: {
                      unavailable_products: "last",
                      fields: "title,product_type,variants.title,vendor",
                    },
                  },
                })
                .done(function (t) {
                  g = !1;
                  var n = {},
                    o = 0;
                  e(y.wrapper).removeClass("hide");
                  for (
                    var a = Object.entries(t.resources.results),
                      s = a.length - 1;
                    s >= 0;
                    s--
                  ) {
                    var r = a[s],
                      h = r[0],
                      u = r[1];
                    switch (((o += u.length), h)) {
                      case "products":
                        n[h] = c(u);
                        break;
                      case "collections":
                        n[h] = d(u);
                        break;
                      default:
                        n[h] = l(u);
                    }
                  }
                  0 === o && i(),
                    e(y.resultDiv).empty().append(resultTemplate(n));
                })));
        }
        function c(e) {
          for (var t = [], i = e.length - 1; i >= 0; i--) {
            var n = e[i],
              o = {
                title: n.title,
                url: n.url,
                image: theme.Images.lazyloadImagePath(n.image),
                vendor: n.vendor,
                price: theme.Currency.formatMoney(n.price),
                compare_price_max: theme.Currency.formatMoney(
                  n.compare_at_price_max
                ),
                on_sale: parseInt(n.compare_at_price_max) > parseInt(n.price),
                custom_label: h(n.tags),
              };
            t.push(o);
          }
          return t;
        }
        function d(e) {
          for (var t = [], i = e.length - 1; i >= 0; i--) {
            var n = e[i],
              o = { title: n.title, url: n.url };
            t.push(o);
          }
          return t;
        }
        function l(e) {
          for (var t = e.length - 1; t >= 0; t--)
            if (e[t].image) {
              var i = theme.Images.lazyloadImagePath(e[t].image);
              e[t].image = i;
            }
          return e;
        }
        function h(e) {
          if (!e.length) return !1;
          for (var t = e.length - 1; t >= 0; t--)
            if (e[t].indexOf("_label_") !== -1)
              return e[t].replace("_label_", "");
          return !1;
        }
        function u(e) {
          return "string" != typeof e
            ? null
            : e.trim().replace(/\ /g, "-").toLowerCase();
        }
        function p(e, t) {}
        var m,
          f = "",
          g = !1,
          v = ".predictive",
          y = {
            form: "#HeaderSearchForm",
            input: 'input[type="search"]',
            wrapper: ".predictive-results",
            searchButton: "[data-predictive-search-button]",
            resultDiv: "#PredictiveResults",
            resultTemplate: "#PredictiveTemplate",
          },
          b = { up_arrow: 38, down_arrow: 40, tab: 9 };
        return { init: t };
      })()),
      (theme.initQuickShop = function () {
        var t = [],
          i = e(".quick-product__btn");
        i.each(function () {
          var i = e(this).data("product-id"),
            n = "QuickShopModal-" + i,
            o = "quick-modal-" + i;
          return t.indexOf(i) > -1
            ? void e('.modal--quick-shop[data-product-id="' + i + '"]').each(
                function (t) {
                  t > 0 && e(this).remove();
                }
              )
            : (new theme.Modals(n, o), void t.push(i));
        });
      }),
      (theme.videoModal = function () {
        function t(t) {
          s(),
            t.preventDefault(),
            theme.LibraryLoader.load("youtubeSdk"),
            theme.config.youTubeReady
              ? n(t)
              : e("body").on("youTubeReady", function () {
                  n(t);
                });
        }
        function i(t) {
          s();
          var i = e(t.currentTarget),
            n = i.next(h.mp4Player);
          n.clone().removeClass("hide").appendTo(h.videoHolder),
            u.open(t),
            e(h.videoHolder).find("video")[0].play(),
            (l = "mp4");
        }
        function n(t) {
          var i = e(t.currentTarget),
            n = a(i.attr("href")),
            o = e.extend({}, c, { videoId: n });
          (o.playerVars.playsinline = theme.config.bpSmall ? 0 : 1),
            (r = new YT.Player(d, o)),
            u.open(t),
            (l = "youtube");
        }
        function o(e) {
          e.target.playVideo();
        }
        function a(e) {
          var t =
              /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/,
            i = e.match(t);
          return !(!i || 11 != i[7].length) && i[7];
        }
        function s() {
          e(h.videoHolder).empty();
        }
        var r = null,
          c = {
            width: 1280,
            height: 720,
            playerVars: {
              autohide: 0,
              autoplay: 1,
              branding: 0,
              cc_load_policy: 0,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              quality: "hd720",
              rel: 0,
              showinfo: 0,
              wmode: "opaque",
            },
            events: { onReady: o },
          },
          d = "VideoHolder",
          l = !1,
          h = {
            videoHolder: "#" + d,
            youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
            mp4Trigger: ".product-video-trigger--mp4",
            mp4Player: ".product-video-mp4-sound",
          };
        if (e(h.youtube).length || e(h.mp4Trigger).length) {
          var u = new theme.Modals("VideoModal", "video-modal", {
            closeOffContentClick: !0,
            solid: !0,
          });
          e(h.youtube).on("click", t),
            e(h.mp4Trigger).on("click", i),
            e("body").on("modalClose.VideoModal", function () {
              r && "youtube" === l
                ? setTimeout(function () {
                    r.destroy();
                  }, 500)
                : s();
            });
        }
      }),
      (theme.RecentlyViewed = (function () {
        function t(t) {
          var n = (this.$container = e(t)),
            o = (this.sectionId = n.attr("data-section-id"));
          (this.namespace = ".recently-viewed" + o),
            e(i.template).length &&
              (this.checkVisibility(),
              e(window).on(
                "scroll" + this.namespace,
                e.throttle(200, this.checkVisibility.bind(this))
              ));
        }
        var i = {
            template: "#RecentlyViewedProduct",
            outputContainer: "#RecentlyViewed-",
          },
          n = !1;
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              if (
                !n &&
                ((n = !0), !e.isEmptyObject(theme.recentlyViewed.recent))
              ) {
                (this.outputContainer = e(i.outputContainer + this.sectionId)),
                  (this.handle = this.$container.attr("data-product-handle"));
                var t = [];
                for (handle in theme.recentlyViewed.recent)
                  "undefined" !== handle && t.push(this.getProductInfo(handle));
                Promise.all(t).then(
                  function (e) {
                    this.setupOutput(e), this.captureProductDetails(e);
                  }.bind(this),
                  function (e) {
                    console.warn(
                      "Theme | recently viewed products failed to load"
                    );
                  }
                );
              }
            },
            checkVisibility: function () {
              theme.isElementVisible(this.$container, 600) &&
                (this.init(), e(window).off("scroll" + this.namespace));
            },
            getProductInfo: function (e) {
              return new Promise(function (t, i) {
                theme.recentlyViewed.productInfo.hasOwnProperty(e)
                  ? t(theme.recentlyViewed.productInfo[e])
                  : jQuery.getJSON("/products/" + e + ".js", function (e) {
                      t(e);
                    });
              });
            },
            setupOutput: function (t) {
              var n = [],
                o = {},
                a = this.$container.attr("data-recent-count"),
                s = 0;
              for (key in t) {
                var r = t[key];
                if (
                  r.handle !== this.handle &&
                  "undefined" != typeof r.handle
                ) {
                  s++,
                    (r.url_formatted = theme.recentlyViewed.recent[r.handle]
                      ? theme.recentlyViewed.recent[r.handle].url
                      : r.url),
                    (r.image_responsive_url =
                      theme.recentlyViewed.recent[r.handle].featuredImage),
                    (r.image_aspect_ratio =
                      theme.recentlyViewed.recent[r.handle].aspectRatio),
                    (r.on_sale = r.compare_at_price > r.price),
                    (r.sold_out = !r.available),
                    (r.price_formatted = theme.Currency.formatMoney(
                      r.price,
                      theme.settings.moneyFormat
                    )),
                    (r.compare_at_price_formatted = theme.Currency.formatMoney(
                      r.compare_at_price,
                      theme.settings.moneyFormat
                    )),
                    (r.price_min_formatted = theme.Currency.formatMoney(
                      r.price_min,
                      theme.settings.moneyFormat
                    )),
                    (r.money_saved = theme.Currency.formatMoney(
                      r.compare_at_price - r.price,
                      theme.settings.moneyFormat
                    ));
                  var c = r.variants[0];
                  if (c && c.unit_price) {
                    var d = "";
                    c.unit_price_measurement &&
                      (1 != c.unit_price_measurement.reference_value &&
                        (d += c.unit_price_measurement.reference_value + " "),
                      (d += c.unit_price_measurement.reference_unit)),
                      (r.unit_price = theme.Currency.formatMoney(c.unit_price)),
                      "" != d && (r.unit_price += "/" + d);
                  }
                  n.unshift(r);
                }
              }
              if (
                ((o = {
                  items: n.slice(0, a),
                  grid_item_width: this.$container.attr("data-grid-item-class"),
                }),
                0 !== n.length)
              ) {
                var l = e(i.template).html(),
                  h = Handlebars.compile(l);
                this.outputContainer.append(h(o)), AOS && AOS.refreshHard();
              }
            },
            captureProductDetails: function (e) {
              for (var t = 0; t < e.length; t++) {
                var i = e[t];
                theme.recentlyViewed.productInfo[i.handle] = i;
              }
              theme.config.hasSessionStorage &&
                sessionStorage.setItem(
                  "recent-products",
                  JSON.stringify(theme.recentlyViewed.productInfo)
                );
            },
            onUnload: function () {
              (n = !1), e("window").off(this.namespace);
            },
          })),
          t
        );
      })()),
      (theme.parallaxSections = {}),
      (theme.Parallax = (function () {
        function t(t, i) {
          (this.$container = e(t)),
            (this.namespace = i.namespace),
            this.$container.length &&
              (i.desktopOnly
                ? this.desktopInit()
                : this.init(this.$container, i));
        }
        var i = 7;
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function (t) {
              var n = (this.$window = e(window)),
                o = this.$container.offset().top;
              n.on(
                "scroll" + this.namespace,
                function (e) {
                  var t = n.scrollTop(),
                    a = (o - t) / i;
                  this.$container.css({
                    transform: "translate3d(0, " + a + "px, 0)",
                  });
                }.bind(this)
              ),
                n.on(
                  "resize" + this.namespace,
                  e.debounce(
                    350,
                    function () {
                      return (
                        n.off(this.namespace),
                        t && !theme.config.bpSmall
                          ? void this.init(!0)
                          : void this.init()
                      );
                    }.bind(this)
                  )
                );
            },
            desktopInit: function () {
              theme.config.bpSmall || this.init(!0),
                e("body").on(
                  "matchSmall",
                  function () {
                    this.destroy();
                  }.bind(this)
                ),
                e("body").on(
                  "matchLarge",
                  function () {
                    this.init(!0);
                  }.bind(this)
                );
            },
            destroy: function () {
              this.$container.removeAttr("style"),
                this.$window.off(this.namespace);
            },
          })),
          t
        );
      })()),
      (theme.Disclosure = (function () {
        function t(e) {
          (this.$container = e),
            (this.cache = {}),
            this._cacheSelectors(),
            this._connectOptions(),
            this._connectToggle(),
            this._onFocusOut();
        }
        var i = {
            disclosureList: "[data-disclosure-list]",
            disclosureToggle: "[data-disclosure-toggle]",
            disclosureInput: "[data-disclosure-input]",
            disclosureOptions: "[data-disclosure-option]",
          },
          n = { listVisible: "disclosure-list--visible" };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            _cacheSelectors: function () {
              this.cache = {
                $disclosureList: this.$container.find(i.disclosureList),
                $disclosureToggle: this.$container.find(i.disclosureToggle),
                $disclosureInput: this.$container.find(i.disclosureInput),
                $disclosureOptions: this.$container.find(i.disclosureOptions),
              };
            },
            _connectToggle: function () {
              this.cache.$disclosureToggle.on(
                "click",
                function (t) {
                  var i = "true" === e(t.currentTarget).attr("aria-expanded");
                  e(t.currentTarget).attr("aria-expanded", !i),
                    this.cache.$disclosureList.toggleClass(n.listVisible);
                }.bind(this)
              );
            },
            _connectOptions: function () {
              this.cache.$disclosureOptions.on(
                "click",
                function (t) {
                  t.preventDefault(),
                    this._submitForm(e(t.currentTarget).data("value"));
                }.bind(this)
              );
            },
            _onFocusOut: function () {
              this.cache.$disclosureToggle.on(
                "focusout",
                function (e) {
                  var t = 0 === this.$container.has(e.relatedTarget).length;
                  t && this._hideList();
                }.bind(this)
              ),
                this.cache.$disclosureList.on(
                  "focusout",
                  function (t) {
                    var i = e(t.currentTarget).has(t.relatedTarget).length > 0,
                      o = this.cache.$disclosureList.hasClass(n.listVisible);
                    o && !i && this._hideList();
                  }.bind(this)
                ),
                this.$container.on(
                  "keyup",
                  function (e) {
                    27 === e.which &&
                      (this._hideList(), this.cache.$disclosureToggle.focus());
                  }.bind(this)
                ),
                e("body").on(
                  "click",
                  function (e) {
                    var t = this.$container.has(e.target).length > 0,
                      i = this.cache.$disclosureList.hasClass(n.listVisible);
                    i && !t && this._hideList();
                  }.bind(this)
                );
            },
            _submitForm: function (t) {
              e("body").addClass("unloading"),
                this.cache.$disclosureInput.val(t),
                this.$container.parents("form").submit();
            },
            _hideList: function () {
              this.cache.$disclosureList.removeClass(n.listVisible),
                this.cache.$disclosureToggle.attr("aria-expanded", !1);
            },
            unload: function () {
              this.cache.$disclosureOptions.off(),
                this.cache.$disclosureToggle.off(),
                this.cache.$disclosureList.off(),
                this.$container.off();
            },
          })),
          t
        );
      })()),
      (theme.ProductMedia = (function () {
        function t(t, o) {
          (s[o] = { loaded: !1 }),
            t.each(function (t) {
              var i = e(this),
                n = i.data("media-id"),
                a = e(i.find("model-viewer")[0]),
                s = a.data("model-id");
              if (0 === t) {
                var l = i.closest(d.mediaGroup).find(d.xrButton);
                c[o] = { $element: l, defaultId: s };
              }
              r[n] = { modelId: s, sectionId: o, $container: i, $element: a };
            }),
            window.Shopify.loadFeatures([
              { name: "shopify-xr", version: "1.0", onLoad: i },
              { name: "model-viewer-ui", version: "1.0", onLoad: n },
            ]),
            theme.LibraryLoader.load("modelViewerUiStyles");
        }
        function i(t) {
          if (!t) {
            if (!window.ShopifyXR)
              return void document.addEventListener(
                "shopify_xr_initialized",
                function () {
                  i();
                }
              );
            for (var n in s)
              if (s.hasOwnProperty(n)) {
                var o = s[n];
                if (o.loaded) continue;
                var a = e("#ModelJson-" + n);
                window.ShopifyXR.addModels(JSON.parse(a.html())),
                  (o.loaded = !0);
              }
            window.ShopifyXR.setupXRElements();
          }
        }
        function n(e) {
          if (!e)
            for (var t in r)
              if (r.hasOwnProperty(t)) {
                var i = r[t];
                !i.modelViewerUi &&
                  Shopify &&
                  (i.modelViewerUi = new Shopify.ModelViewerUI(i.$element)),
                  o(i);
              }
        }
        function o(e) {
          var t = c[e.sectionId];
          e.$container.on("mediaVisible", function () {
            t.$element.attr("data-shopify-model3d-id", e.modelId),
              theme.config.isTouch || e.modelViewerUi.play();
          }),
            e.$container
              .on("mediaHidden", function () {
                t.$element.attr("data-shopify-model3d-id", t.defaultId),
                  e.modelViewerUi.pause();
              })
              .on("xrLaunch", function () {
                e.modelViewerUi.pause();
              });
        }
        function a(e) {
          for (var t in r)
            if (r.hasOwnProperty(t)) {
              var i = r[t];
              i.sectionId === e && delete r[t];
            }
          delete s[e];
        }
        var s = {},
          r = {},
          c = {},
          d = {
            mediaGroup: "[data-product-single-media-group]",
            xrButton: "[data-shopify-xr]",
          };
        return { init: t, removeSectionModels: a };
      })()),
      (theme.collectionTemplate = (function () {
        function t() {
          e(window).on("popstate", function (e) {
            e && a(location.href);
          }),
            theme.config.stickyHeader &&
              (o(), e(window).on("resize", e.debounce(150, o))),
            i();
        }
        function i() {
          e("body").on("click", c.tags, function (t) {
            var i = e(this);
            if (
              (theme.FilterDrawer && theme.FilterDrawer.close(),
              !i.hasClass("no-ajax") && (t.preventDefault(), !r))
            ) {
              r = !0;
              var i = e(t.currentTarget),
                o = i.parent(),
                s = i.attr("href");
              d.combineTags
                ? o.hasClass(l.activeTag)
                  ? o.removeClass(l.activeTag)
                  : (o.addClass(l.activeTag),
                    i.parent("li").hasClass(l.removeTagParent)
                      ? e(this).parent().remove()
                      : e(c.activeTagList).append(
                          '<li class="tag tag--remove"><a class="btn btn--small">' +
                            i.text() +
                            "</a></li>"
                        ))
                : (e(c.tags).parent().removeClass(l.activeTag),
                  o.addClass(l.activeTag)),
                n(!0),
                history.pushState({}, "", s),
                e(c.collectionGrid).addClass("unload"),
                a(s);
            }
          });
        }
        function n(t) {
          var i;
          if (
            ((i = theme.config.bpSmall
              ? e("[data-scroll-to]").offset().top - 60
              : e("#CollectionAjaxResult").offset().top + 1),
            theme.config.stickyHeader)
          ) {
            var n = e(".site-header").outerHeight(!0);
            i -= n;
          }
          t
            ? e("html, body").animate({ scrollTop: i }, 300)
            : e("html, body").scrollTop(i);
        }
        function o() {
          var t = e(".site-header").outerHeight(!0);
          e(c.filters).css("top", t + 10);
        }
        function a(t) {
          (t = t.indexOf("?") === -1 ? t + "?view=ajax" : t + "&view=ajax"),
            e("#CollectionAjaxResult").load(
              t + " #CollectionAjaxContent",
              function () {
                (r = !1),
                  theme.reinitSection("collection-template"),
                  theme.collectionTemplate.reinit();
              }.bind(this)
            );
        }
        function s() {
          (d.combineTags = e(c.sidebar).data("combine-tags")),
            n(!1),
            theme.reinitProductGridItem(),
            e("body").trigger("resize");
        }
        var r = !1,
          c = {
            collectionGrid: ".collection-grid__wrapper",
            sidebar: "#CollectionSidebar",
            activeTagList: ".tag-list--active-tags",
            tags: ".tag-list a",
            filters: ".collection-filter",
          },
          d = { combineTags: e(c.sidebar).data("combine-tags") },
          l = { activeTag: "tag--active", removeTagParent: "tag--remove" };
        return { init: t, reinit: s };
      })()),
      (theme.customerTemplates = (function () {
        function t() {
          e("#RecoverPassword").on("click", function (e) {
            e.preventDefault(), i();
          }),
            e("#HideRecoverPasswordLink").on("click", function (e) {
              e.preventDefault(), i();
            });
        }
        function i() {
          e("#RecoverPasswordForm").toggleClass("hide"),
            e("#CustomerLoginForm").toggleClass("hide");
        }
        function n() {
          var t = e(".reset-password-success");
          t.length && e("#ResetSuccess").removeClass("hide");
        }
        function o() {
          var t = e("#AddressNewForm"),
            i = e(".js-address-form");
          t.length &&
            i.length &&
            (Shopify &&
              e(".js-address-country").each(function () {
                var t = e(this),
                  i = t.data("country-id"),
                  n = t.data("province-id"),
                  o = t.data("province-container-id");
                Shopify &&
                  new Shopify.CountryProvinceSelector(i, n, { hideElement: o });
              }),
            e(".address-new-toggle").on("click", function () {
              t.toggleClass("hide");
            }),
            e(".address-edit-toggle").on("click", function () {
              var t = e(this).data("form-id");
              e("#EditAddress_" + t).toggleClass("hide");
            }),
            e(".address-delete").on("click", function () {
              var t = e(this),
                i = t.data("form-id"),
                n = t.data("confirm-message");
              confirm(n || "Are you sure you wish to delete this address?") &&
                Shopify &&
                Shopify.postLink("/account/addresses/" + i, {
                  parameters: { _method: "delete" },
                });
            }));
        }
        function a() {
          var e = window.location.hash;
          "#recover" === e && i();
        }
        return {
          init: function () {
            a(), t(), n(), o();
          },
        };
      })()),
      (theme.Product = (function () {
        function t(t, n) {
          var o = e("#" + n),
            a = o.attr("id");
          f[a] = t.target;
          f[a];
          r(o),
            "muted" === m[a].style ? f[a].mute() : c(o),
            (o.closest(p.startingSlide).length ||
              1 === o.data("image-count")) &&
              "muted" === m[a].style &&
              (f[a].playVideo(), i(a));
        }
        function i(t) {
          n(t), e(window).on("scroll." + t, { id: t }, e.throttle(150, n));
        }
        function n(t) {
          var i;
          if ("string" == typeof t) i = t;
          else {
            if (!t.data) return;
            i = t.data.id;
          }
          if (theme.isElementVisible(e("#" + i))) {
            if (m[i] && "unmuted" === m[i].style) return;
            o(i);
          } else a(i);
        }
        function o(e) {
          f[e] && "function" == typeof f[e].playVideo && f[e].playVideo();
        }
        function a(e) {
          f[e] && "function" == typeof f[e].pauseVideo && f[e].pauseVideo();
        }
        function s(t, i) {
          var n = e("#" + i),
            o = n.attr("id"),
            a = f[o];
          switch (t.data) {
            case -1:
              m[o].attemptedToPlay && (c(n), d(n));
              break;
            case 0:
              m[o] && m[o].loop && a.playVideo();
              break;
            case 1:
              c(n);
              break;
            case 3:
              m[o].attemptedToPlay = !0;
          }
        }
        function r(e) {
          e.closest(p.videoParent).addClass(u.loading);
        }
        function c(e) {
          e.closest(p.videoParent).removeClass(u.loading).addClass(u.loaded);
        }
        function d(e) {
          e.closest(p.videoParent).addClass(u.interactable);
        }
        function l(t) {
          var i = (this.$container = e(t)),
            n = (this.sectionId = i.attr("data-section-id"));
          (this.inModal = i.closest(".modal").length),
            this.$modal,
            (this.settings = {
              enableHistoryState: i.data("enable-history-state") || !1,
              namespace: ".product-" + n,
              inventory: i.data("inventory") || !1,
              incomingInventory: i.data("incoming-inventory") || !1,
              modalInit: !1,
              slickMainInitialized: !1,
              slickThumbInitialized: !1,
              thumbArrows: !1,
              thumbVertical: !1,
              hasImages: !0,
              hasMultipleImages: !1,
              has3d: !1,
              imageSize: "620x",
              videoLooping: i.data("video-looping"),
            }),
            this.inModal &&
              ((this.settings.enableHistoryState = !1),
              (this.settings.namespace = ".product-" + n + "-modal"),
              (this.$modal = e("#QuickShopModal-" + n))),
            (this.selectors = {
              variantsJson: "VariantsJson-" + n,
              currentVariantJson: "CurrentVariantJson-" + n,
              video: "ProductVideo-" + n,
              media: "[data-product-media-type-model]",
              closeMedia: ".product-single__close-media",
              photoThumbs: ".product__thumb-" + n,
              thumbSlider: "#ProductThumbs-" + n,
              mainSlider: "#ProductPhotos-" + n,
              imageContainer: "[data-product-images]",
              productImageMain: ".product-image-main--" + n,
              dotsContainer: ".product__photo-dots--" + n,
              priceWrapper: ".product__price-wrap-" + n,
              price: "#ProductPrice-" + n,
              comparePrice: "#ComparePrice-" + n,
              savePrice: "#SavePrice-" + n,
              priceA11y: "#PriceA11y-" + n,
              comparePriceA11y: "#ComparePriceA11y-" + n,
              unitWrapper: ".product__unit-price-wrapper--" + n,
              unitPrice: ".product__unit-price--" + n,
              unitPriceBaseUnit: ".product__unit-base--" + n,
              sku: "#Sku-" + n,
              inventory: "#ProductInventory-" + n,
              incomingInventory: "#ProductIncomingInventory-" + n,
              addToCart: "#AddToCart-" + n,
              addToCartText: "#AddToCartText-" + n,
              originalSelectorId: "#ProductSelect-" + n,
              singleOptionSelector: ".variant__input-" + n,
              variantColorSwatch: ".variant__input--color-swatch-" + n,
              modalFormHolder: "#ProductFormHolder-" + n,
              formContainer: "#AddToCartForm-" + n,
            }),
            (this.$mainSlider = e(this.selectors.mainSlider)),
            (this.$thumbSlider = e(this.selectors.thumbSlider)),
            (this.$firstProductImage = this.$mainSlider.find("img").first()),
            this.$firstProductImage.length || (this.settings.hasImages = !1),
            this.init();
        }
        var h,
          u = {
            onSale: "on-sale",
            disabled: "disabled",
            isModal: "is-modal",
            loading: "loading",
            loaded: "loaded",
            hidden: "hide",
            interactable: "video-interactable",
            visuallyHide: "visually-invisible",
          },
          p = {
            productVideo: ".product__video",
            videoParent: ".product__video-wrapper",
            currentSlide: ".slick-current",
            startingSlide: ".starting-slide",
          },
          m = {},
          f = [],
          g = {
            height: "480",
            width: "850",
            playerVars: {
              autohide: 0,
              autoplay: 0,
              branding: 0,
              cc_load_policy: 0,
              controls: 0,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              quality: "hd720",
              rel: 0,
              showinfo: 0,
              wmode: "opaque",
            },
          };
        return (
          (l.prototype = e.extend({}, l.prototype, {
            init: function () {
              this.inModal &&
                (this.$container.addClass(u.isModal),
                e("body")
                  .off("modalOpen.QuickShopModal-" + this.sectionId)
                  .off("modalClose.QuickShopModal-" + this.sectionId),
                e("body").on(
                  "modalOpen.QuickShopModal-" + this.sectionId,
                  this.openModalProduct.bind(this)
                ),
                e("body").on(
                  "modalClose.QuickShopModal-" + this.sectionId,
                  this.closeModalProduct.bind(this)
                )),
                this.inModal ||
                  (this.stringOverrides(),
                  this.formSetup(),
                  this.productSetup(),
                  this.checkIfVideos(),
                  this.createImageCarousels(),
                  this.customMediaListners(),
                  this.addIdToRecentlyViewed());
            },
            formSetup: function () {
              theme.settings.dynamicVariantsEnable &&
                (this.$variantSelectors = e(this.selectors.formContainer).find(
                  this.selectors.singleOptionSelector
                )),
                this.initQtySelector(),
                this.initAjaxProductForm(),
                this.initVariants();
            },
            productSetup: function () {
              this.setImageSizes(),
                this.initImageSwitch(),
                this.initImageZoom(),
                this.initModelViewerLibraries(),
                this.initShopifyXrLaunch();
            },
            addIdToRecentlyViewed: function () {
              var e = this.$container.attr("data-product-handle"),
                t = this.$container.attr("data-product-url"),
                i = this.$container.attr("data-aspect-ratio"),
                n = this.$container.attr("data-img-url");
              theme.recentlyViewed.recent.hasOwnProperty(e) &&
                delete theme.recentlyViewed.recent[e],
                (theme.recentlyViewed.recent[e] = {
                  url: t,
                  aspectRatio: i,
                  featuredImage: n,
                }),
                theme.config.hasLocalStorage &&
                  window.localStorage.setItem(
                    "theme-recent",
                    JSON.stringify(theme.recentlyViewed.recent)
                  );
            },
            stringOverrides: function () {
              (theme.productStrings = theme.productStrings || {}),
                e.extend(theme.strings, theme.productStrings);
            },
            initVariants: function () {
              if (document.getElementById(this.selectors.variantsJson)) {
                this.variantsObject = JSON.parse(
                  document.getElementById(this.selectors.variantsJson).innerHTML
                );
                var t = {
                  $container: this.$container,
                  enableHistoryState: this.settings.enableHistoryState,
                  singleOptionSelector: this.selectors.singleOptionSelector,
                  originalSelectorId: this.selectors.originalSelectorId,
                  variants: this.variantsObject,
                };
                e(this.selectors.variantColorSwatch).length &&
                  e(this.selectors.variantColorSwatch).on(
                    "change",
                    function (t) {
                      var i = e(t.currentTarget),
                        n = i.data("color-name"),
                        o = i.data("color-index");
                      this.updateColorName(n, o);
                    }.bind(this)
                  ),
                  (this.variants = new theme.Variants(t)),
                  this.$container
                    .on(
                      "variantChange" + this.settings.namespace,
                      this.updateCartButton.bind(this)
                    )
                    .on(
                      "variantImageChange" + this.settings.namespace,
                      this.updateVariantImage.bind(this)
                    )
                    .on(
                      "variantPriceChange" + this.settings.namespace,
                      this.updatePrice.bind(this)
                    )
                    .on(
                      "variantUnitPriceChange" + this.settings.namespace,
                      this.updateUnitPrice.bind(this)
                    ),
                  e(this.selectors.sku).length &&
                    this.$container.on(
                      "variantSKUChange" + this.settings.namespace,
                      this.updateSku.bind(this)
                    ),
                  (this.settings.inventory ||
                    this.settings.incomingInventory) &&
                    this.$container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateInventory.bind(this)
                    ),
                  theme.settings.dynamicVariantsEnable &&
                    document.getElementById(
                      this.selectors.currentVariantJson
                    ) &&
                    ((this.currentVariantObject = JSON.parse(
                      document.getElementById(this.selectors.currentVariantJson)
                        .innerHTML
                    )),
                    this.$variantSelectors.on(
                      "change" + this.settings.namespace,
                      this.updateVariantAvailability.bind(this)
                    ),
                    this.setCurrentVariantAvailability(
                      this.currentVariantObject,
                      !0
                    ));
              }
            },
            initQtySelector: function () {
              this.$container.find(".js-qty__wrapper").each(function () {
                new theme.QtySelector(e(this), { namespace: ".product" });
              });
            },
            initAjaxProductForm: function () {
              "drawer" === theme.settings.cartType &&
                new theme.AjaxProduct(e(this.selectors.formContainer));
            },
            setCurrentVariantAvailability: function (t) {
              var i = { option1: [], option2: [], option3: [] };
              this.disableVariantGroup(
                e(this.selectors.formContainer).find(".variant-input-wrap")
              );
              var n = this.variantsObject.filter(function (e) {
                  return (
                    t.id !== e.id &&
                    ((t.option2 === e.option2 && t.option3 === e.option3) ||
                      (t.option1 === e.option1 && t.option3 === e.option3) ||
                      (t.option1 === e.option1 && t.option2 === e.option2) ||
                      void 0)
                  );
                }),
                o = { variant: t };
              n = Object.assign({}, o, n);
              for (var a in n)
                if (n.hasOwnProperty(a)) {
                  var s = n[a],
                    r = s.option1,
                    c = s.option2,
                    d = s.option3;
                  r && i.option1.indexOf(r) === -1 && i.option1.push(r),
                    c && i.option2.indexOf(c) === -1 && i.option2.push(c),
                    d && i.option3.indexOf(d) === -1 && i.option3.push(d);
                }
              i.option1.length &&
                this.enableVariantOptionByValue(i.option1, "option1"),
                i.option2.length &&
                  this.enableVariantOptionByValue(i.option2, "option2"),
                i.option3.length &&
                  this.enableVariantOptionByValue(i.option3, "option3");
            },
            updateVariantAvailability: function (t, i, n) {
              if (i && n)
                var o = i,
                  a = n;
              else
                var s = e(t.currentTarget),
                  o = s.val() ? s.val() : t.currentTarget.value,
                  a = s.data("index");
              var r = this.variantsObject.filter(function (e) {
                return e[a] === o;
              });
              e(this.selectors.formContainer)
                .find(".variant-input-wrap")
                .each(
                  function (t, i) {
                    var n = e(i),
                      o = n.data("index");
                    if (o !== a) {
                      this.disableVariantGroup(n);
                      for (var s = 0; s < r.length; s++)
                        this.enableVariantOption(n, r[s][o]);
                    }
                  }.bind(this)
                );
            },
            disableVariantGroup: function (e) {
              "dropdown" === theme.settings.dynamicVariantType
                ? e.find("option").prop("disabled", !0)
                : (e.find("input").prop("disabled", !0),
                  e.find("label").toggleClass("disabled", !0));
            },
            enableVariantOptionByValue: function (t, i) {
              for (
                var n = e(this.selectors.formContainer).find(
                    '.variant-input-wrap[data-index="' + i + '"]'
                  ),
                  o = 0;
                o < t.length;
                o++
              )
                this.enableVariantOption(n, t[o]);
            },
            enableVariantOption: function (e, t) {
              if (
                ((t = t.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1")),
                "dropdown" === theme.settings.dynamicVariantType)
              )
                e.find('option[value="' + t + '"]').prop("disabled", !1);
              else {
                var i = e.find('.variant-input[data-value="' + t + '"]');
                i.find("input").prop("disabled", !1),
                  i.find("label").toggleClass("disabled", !1);
              }
            },
            updateColorName: function (t, i) {
              e("#VariantColorLabel-" + this.sectionId + "-" + i).text(t);
            },
            updateCartButton: function (t) {
              var i = t.variant;
              if (i)
                if (i.available) {
                  e(this.selectors.addToCart)
                    .removeClass(u.disabled)
                    .prop("disabled", !1);
                  var n = e(this.selectors.addToCartText).data("default-text");
                  e(this.selectors.addToCartText).html(n);
                } else
                  e(this.selectors.addToCart)
                    .addClass(u.disabled)
                    .prop("disabled", !0),
                    e(this.selectors.addToCartText).html(theme.strings.soldOut);
              else
                e(this.selectors.addToCart)
                  .addClass(u.disabled)
                  .prop("disabled", !0),
                  e(this.selectors.addToCartText).html(
                    theme.strings.unavailable
                  );
            },
            updatePrice: function (t) {
              var i = t.variant;
              if (i)
                if (
                  (e(this.selectors.price)
                    .html(
                      theme.Currency.formatMoney(
                        i.price,
                        theme.settings.moneyFormat
                      )
                    )
                    .show(),
                  i.compare_at_price > i.price)
                ) {
                  e(this.selectors.comparePrice).html(
                    theme.Currency.formatMoney(
                      i.compare_at_price,
                      theme.settings.moneyFormat
                    )
                  ),
                    e(this.selectors.priceWrapper).removeClass("hide"),
                    e(this.selectors.price).addClass(u.onSale),
                    e(this.selectors.comparePriceA11y).attr(
                      "aria-hidden",
                      "false"
                    ),
                    e(this.selectors.priceA11y).attr("aria-hidden", "false");
                  var n = i.compare_at_price - i.price;
                  (n =
                    "percent" == theme.settings.saveType
                      ? Math.round((100 * n) / i.compare_at_price) + "%"
                      : theme.Currency.formatMoney(
                          n,
                          theme.settings.moneyFormat
                        )),
                    e(this.selectors.savePrice)
                      .removeClass("hide")
                      .html(
                        theme.strings.savePrice.replace("[saved_amount]", n)
                      );
                } else
                  e(this.selectors.priceWrapper).addClass("hide"),
                    e(this.selectors.price).removeClass(u.onSale),
                    e(this.selectors.comparePriceA11y).attr(
                      "aria-hidden",
                      "true"
                    ),
                    e(this.selectors.priceA11y).attr("aria-hidden", "true"),
                    e(this.selectors.savePrice).addClass("hide");
            },
            updateUnitPrice: function (t) {
              var i = t.variant;
              i && i.unit_price
                ? (e(this.selectors.unitPrice).html(
                    theme.Currency.formatMoney(
                      i.unit_price,
                      theme.settings.moneyFormat
                    )
                  ),
                  e(this.selectors.unitPriceBaseUnit).text(
                    theme.Currency.getBaseUnit(i)
                  ),
                  e(this.selectors.unitWrapper)
                    .removeClass("hide")
                    .removeClass(u.visuallyHide))
                : e(this.selectors.unitWrapper).addClass(u.visuallyHide);
            },
            updateSku: function (t) {
              var i = t.variant,
                n = "";
              i && (i.sku && (n = i.sku), e(this.selectors.sku).html(n));
            },
            updateInventory: function (e) {
              var t = e.variant;
              if (
                !t ||
                !t.inventory_management ||
                "continue" === t.inventory_policy
              )
                return (
                  this.toggleInventoryQuantity(!1),
                  void this.toggleIncomingInventory(!1)
                );
              if (
                "shopify" === t.inventory_management &&
                window.inventories &&
                window.inventories[this.sectionId]
              ) {
                variantInventoryObject =
                  window.inventories[this.sectionId][t.id];
                var i = variantInventoryObject.quantity,
                  n = !0,
                  o = !1;
                (i <= 0 || i > theme.settings.inventoryThreshold) && (n = !1),
                  this.toggleInventoryQuantity(n, i),
                  !n && variantInventoryObject.incoming && (o = !0),
                  this.toggleIncomingInventory(
                    o,
                    t.available,
                    variantInventoryObject.next_incoming_date
                  );
              }
            },
            toggleInventoryQuantity: function (t, i) {
              this.settings.inventory || (t = !1),
                t
                  ? e(this.selectors.inventory)
                      .removeClass("hide")
                      .text(theme.strings.stockLabel.replace("[count]", i))
                  : e(this.selectors.inventory).addClass("hide");
            },
            toggleIncomingInventory: function (t, i, n) {
              if ((this.settings.incomingInventory || (t = !1), t)) {
                var o = i
                  ? theme.strings.willNotShipUntil.replace("[date]", n)
                  : theme.strings.willBeInStockAfter.replace("[date]", n);
                n || (o = theme.strings.waitingForStock),
                  e(this.selectors.incomingInventory)
                    .removeClass("hide")
                    .text(o);
              } else e(this.selectors.incomingInventory).addClass("hide");
            },
            checkIfVideos: function () {
              var t = this.$mainSlider.find(p.productVideo);
              if (!t.length) return !1;
              var i = [];
              return (
                t.each(function () {
                  var t = e(this).data("video-type");
                  i.indexOf(t) < 0 && i.push(t);
                }),
                i.indexOf("youtube") > -1 &&
                  (theme.config.youTubeReady
                    ? this.loadYoutubeVideos(t)
                    : (theme.LibraryLoader.load("youtubeSdk"),
                      e("body").on(
                        "youTubeReady" + this.settings.namespace,
                        function () {
                          this.loadYoutubeVideos(t);
                        }.bind(this)
                      ))),
                i.indexOf("mp4") > -1 && this.loadMp4Videos(t),
                i
              );
            },
            loadMp4Videos: function (t) {
              t.each(function () {
                var t = e(this);
                if ("mp4" == t.data("video-type")) {
                  var i = t.attr("id");
                  t.data("video-id");
                  m[i] = {
                    type: "mp4",
                    divId: i,
                    style: t.data("video-style"),
                  };
                }
              });
            },
            loadYoutubeVideos: function (i) {
              i.each(function () {
                var i = e(this);
                if ("youtube" == i.data("video-type")) {
                  var n = i.attr("id"),
                    o = i.data("youtube-id");
                  m[n] = {
                    type: "youtube",
                    id: n,
                    videoId: o,
                    style: i.data("video-style"),
                    loop: i.data("video-loop"),
                    attemptedToPlay: !1,
                    events: {
                      onReady: function (e) {
                        t(e, n);
                      },
                      onStateChange: function (e) {
                        s(e, n);
                      },
                    },
                  };
                }
              });
              for (var n in m)
                if ("youtube" === m[n].type && m.hasOwnProperty(n)) {
                  var o = e.extend({}, g, m[n]);
                  "muted" === o.style ||
                    ((o.playerVars.controls = 1), (o.playerVars.autoplay = 0)),
                    (f[n] = new YT.Player(n, o));
                }
              h = !0;
            },
            initVideo: function (e) {
              var t = e.data("video-type"),
                i = e.attr("id");
              "mp4" === t && "muted" === m[i].style && this.playMp4Video(i),
                "youtube" === t &&
                  h &&
                  "muted" === m[i].style &&
                  this.requestToPlayYoutubeVideo(i),
                this.inModal && this.resizeSlides();
            },
            stopVideo: function (e, t) {
              e || (this.stopYoutubeVideo(), this.stopMp4Video()),
                "youtube" === t && this.stopYoutubeVideo(e),
                "mp4" === t && this.stopMp4Video(e);
            },
            getVideoType: function (e) {
              return e.data("video-type");
            },
            getVideoId: function (e) {
              return e.attr("id");
            },
            requestToPlayYoutubeVideo: function (t, i) {
              if (theme.config.youTubeReady) {
                var n = e("#" + t);
                return (
                  r(n),
                  "function" != typeof f[t].playVideo
                    ? void setTimeout(
                        function () {
                          this.playYoutubeVideo(t, i);
                        }.bind(this),
                        1e3
                      )
                    : void this.playYoutubeVideo(t, i)
                );
              }
            },
            playYoutubeVideo: function (t, n) {
              var o = e("#" + t);
              c(o),
                "function" == typeof f[t].playVideo && f[t].playVideo(),
                n || i(t);
            },
            stopYoutubeVideo: function (t) {
              if (theme.config.youTubeReady)
                if (t && f[t])
                  "function" == typeof f[t].pauseVideo && f[t].pauseVideo(),
                    e(window).off("scroll." + t);
                else
                  for (key in f) {
                    var i = this.$container.find("#" + key);
                    i.length &&
                      "function" == typeof f[key].pauseVideo &&
                      (f[key].pauseVideo(), e(window).off("scroll." + key));
                  }
            },
            playMp4Video: function (t) {
              var i = e("#" + t);
              c(i);
              var n = i[0].play();
              void 0 !== n &&
                n
                  .then(function () {})
                  .catch(function (e) {
                    i[0].setAttribute("controls", ""),
                      i
                        .closest(p.videoParent)
                        .attr("data-video-style", "unmuted");
                  });
            },
            stopMp4Video: function (t) {
              if (t) e("#" + t)[0].pause();
              else
                for (var i in m) {
                  var n = this.$container.find("#" + i);
                  if (n.length && "mp4" === m[i].type) {
                    var o = e("#" + m[i].divId)[0];
                    o && "function" == typeof o.pause && o.pause();
                  }
                }
            },
            initImageZoom: function () {
              var t = e(this.selectors.imageContainer, this.$container);
              new theme.Photoswipe(t[0], this.sectionId);
            },
            setImageSizes: function () {
              if (this.settings.hasImages) {
                var e = this.$firstProductImage[0].currentSrc;
                e && (this.settings.imageSize = theme.Images.imageSize(e));
              }
            },
            updateVariantImage: function (t) {
              var i = t.variant,
                n =
                  (theme.Images.getSizedImageUrl(
                    i.featured_media.preview_image.src,
                    this.settings.imageSize
                  ),
                  e('.product__thumb[data-id="' + i.featured_media.id + '"]')),
                o = this._slideIndex(n.closest(".product__thumb-item"));
              "undefined" != typeof o && this.$mainSlider.slick("slickGoTo", o);
            },
            initImageSwitch: function () {
              e(this.selectors.photoThumbs).length &&
                e(this.selectors.photoThumbs)
                  .on("click", function (e) {
                    e.preventDefault();
                  })
                  .on(
                    "focus",
                    function (t) {
                      if (this.settings.slickThumbInitialized) {
                        var i = e(t.currentTarget).data("index");
                        void 0 !== i && this.$thumbSlider.slick("slickGoTo", i);
                      }
                    }.bind(this)
                  )
                  .on(
                    "keydown",
                    function (e) {
                      13 === e.keyCode &&
                        this.$container.find(p.currentSlide).focus();
                    }.bind(this)
                  );
            },
            createImageCarousels: function () {
              if (
                !this.$thumbSlider.length ||
                e(this.selectors.photoThumbs).length < 2
              ) {
                var t = e(this.selectors.productImageMain).find(p.productVideo);
                return void (t.length && this.initVideo(t));
              }
              (this.settings.hasMultipleImages = !0),
                (this.settings.has3d = this.$container.find(
                  this.selectors.media
                ).length);
              var i = this.$mainSlider.find(".starting-slide"),
                n = this._slideIndex(i);
              this.$mainSlider.off("init"),
                this.$mainSlider.off("beforeChange"),
                this.$mainSlider.on("init", this.mainSlideInit.bind(this)),
                this.$mainSlider.on(
                  "beforeChange",
                  this.beforeSlideChange.bind(this)
                ),
                this.$thumbSlider.on("init", this.thumbSlideInit.bind(this)),
                (this.mainSliderArgs = {
                  infinite: !this.settings.has3d,
                  arrows: !1,
                  dots: !0,
                  adaptiveHeight: !0,
                  initialSlide: n,
                  appendDots: this.selectors.dotsContainer,
                }),
                (this.thumbSliderArgs = { accessibility: !1, initialSlide: n });
              var o = this.setSliderArgs();
              this.initSliders(o),
                e("body").on(
                  "matchSmall matchLarge",
                  function () {
                    var e = this.setSliderArgs();
                    this.initSliders(e);
                  }.bind(this)
                ),
                AOS && AOS.refresh();
            },
            initSliders: function (e) {
              this.destroyImageCarousels(),
                this.$mainSlider.slick(e.main),
                theme.config.bpSmall || this.$thumbSlider.slick(e.thumbs),
                (this.settings.slickMainInitialized = !0);
            },
            setSliderArgs: function () {
              var t = {},
                i = (this.settings.thumbVertical =
                  "beside" === this.$thumbSlider.data("position")),
                n = (this.settings.thumbArrows =
                  this.$thumbSlider.data("arrows"));
              return (
                theme.config.bpSmall
                  ? ((t.main = this.mainSliderArgs),
                    (t.thumbs = this.thumbSliderArgs))
                  : ((t.main = e.extend({}, this.mainSliderArgs, {
                      asNavFor: this.selectors.thumbSlider,
                      adaptiveHeight: !i,
                      dots: !1,
                      infinite: !1,
                      fade: !0,
                    })),
                    (t.thumbs = e.extend({}, this.thumbSliderArgs, {
                      asNavFor: this.selectors.mainSlider,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: n,
                      dots: !1,
                      vertical: i,
                      verticalSwiping: i,
                      focusOnSelect: !0,
                      infinite: !1,
                      customHeightMatching: !n && i,
                      customSlideAdvancement: !0,
                    }))),
                t
              );
            },
            destroyImageCarousels: function () {
              this.$mainSlider &&
                this.settings.slickMainInitialized &&
                (this.$mainSlider.slick("unslick"),
                (this.settings.slickMainInitialized = !1)),
                this.$thumbSlider &&
                  this.settings.slickThumbInitialized &&
                  (this.$thumbSlider.slick("unslick"),
                  (this.settings.slickThumbInitialized = !1)),
                (this.settings.slickMainInitialized = !1),
                (this.settings.slickThumbInitialized = !1);
            },
            mainSlideInit: function (e, t) {
              var i = t.$slider,
                n = i.find(p.currentSlide),
                o = n.find(p.productVideo);
              o.length && this.initVideo(o);
            },
            thumbSlideInit: function (e, t) {
              (this.settings.slickThumbInitialized = !0),
                this.settings.thumbArrows &&
                  this.$thumbSlider.on(
                    "setPosition",
                    this.thumbSlideArrowVisibility.bind(this)
                  );
            },
            thumbSlideArrowVisibility: function (e, t) {
              var i = t.$slider,
                n = i.find(".slick-arrow"),
                o = !1;
              if (this.settings.thumbVertical) {
                var a = i.find(".slick-track").height();
                a >= i.height() && (o = !0);
              } else {
                var s = i.find(".slick-track").width();
                s >= i.width() && (o = !0);
              }
              o ? n.removeClass("hide") : n.addClass("hide");
            },
            beforeSlideChange: function (t, i, n, o) {
              var a = i.$slider,
                s = a.find(p.currentSlide),
                r = s.find(".product__video"),
                d = a.find('.slick-slide[data-slick-index="' + o + '"]'),
                l = d.find(".product__video");
              if (n !== o && r.length) {
                var u = this.getVideoType(r),
                  f = this.getVideoId(r);
                f && this.stopVideo(f, u);
              }
              if (l.length) {
                var g = this.getVideoType(l),
                  v = this.getVideoId(l);
                v &&
                  "youtube" === g &&
                  (h
                    ? m[v] &&
                      "muted" === m[v].style &&
                      this.requestToPlayYoutubeVideo(v, !0)
                    : e("body").on(
                        "youTubeReady" + this.settings.namespace,
                        function () {
                          m[v] &&
                            "muted" === m[v].style &&
                            this.requestToPlayYoutubeVideo(v, !0);
                        }.bind(this)
                      )),
                  v &&
                    m[v] &&
                    "muted" === m[v].style &&
                    "mp4" === g &&
                    this.playMp4Video(v),
                  v && m[v] && "muted" != m[v].style && c(e("#" + v));
              }
              var y = s.find(this.selectors.media);
              y.length && y.trigger("mediaHidden");
              var b = d.find(this.selectors.media);
              b.length &&
                (b.trigger("mediaVisible"),
                d.find(".shopify-model-viewer-ui__button").attr("tabindex", 0),
                d.find(".product-single__close-media").attr("tabindex", 0));
            },
            resizeSlides: function () {
              this.settings.hasMultipleImages &&
                (e(window).trigger("resize.slick"),
                setTimeout(
                  function () {
                    this.$mainSlider &&
                      this.settings.slickMainInitialized &&
                      this.$mainSlider.slick("setPosition"),
                      this.$thumbSlider &&
                        this.settings.slickThumbInitialized &&
                        this.$thumbSlider.slick("setPosition");
                  }.bind(this),
                  500
                ));
            },
            _slideIndex: function (e) {
              return e.data("index");
            },
            openModalProduct: function () {
              if (!this.settings.modalInit) {
                var t = e(this.selectors.modalFormHolder),
                  i = t.data("url"),
                  n = t.data("template");
                n || (i += "?view=ajax"),
                  t.load(
                    i + " #AddToCartForm-" + this.sectionId,
                    function () {
                      t.addClass("is-active"),
                        this.formSetup(),
                        Shopify &&
                          Shopify.PaymentButton &&
                          Shopify.PaymentButton.init();
                    }.bind(this)
                  ),
                  this.productSetup(),
                  this.loadModalContent(),
                  this.createImageCarousels(),
                  this.customMediaListners(),
                  (this.settings.modalInit = !0);
              }
              this.resizeSlides(), this.addIdToRecentlyViewed();
            },
            closeModalProduct: function () {
              this.stopVideo(),
                e("body").off(this.settings.namespace),
                e(window).off(this.settings.namespace);
            },
            loadModalContent: function () {
              var t = this.checkIfVideos();
              t &&
                t.indexOf("mp4") > -1 &&
                this.$modal
                  .find('.product__video[data-video-type="mp4"]')
                  .find(".product__video-src")
                  .each(
                    function (t, i) {
                      var n = e(i),
                        o = n.attr("src"),
                        a = n.attr("type"),
                        s = document.createElement("source");
                      (s.src = o), (s.type = a), n.after(s);
                    }.bind(this)
                  );
            },
            initModelViewerLibraries: function () {
              var t = e(this.selectors.media, this.$container);
              t.length < 1 || theme.ProductMedia.init(t, this.sectionId);
            },
            initShopifyXrLaunch: function () {
              var t = this;
              e(document).on("shopify_xr_launch", function () {
                var i = e(
                  t.selectors.productMediaWrapper + ":not(." + u.hidden + ")",
                  t.$container
                );
                i.trigger("xrLaunch");
              });
            },
            customMediaListners: function () {
              e("body").on(
                "click",
                this.selectors.closeMedia,
                function () {
                  this.$mainSlider
                    .find(p.currentSlide)
                    .find(this.selectors.media)
                    .trigger("mediaHidden");
                }.bind(this)
              ),
                this.$container
                  .find("model-viewer")
                  .on(
                    "shopify_model_viewer_ui_toggle_play",
                    function (e) {
                      this.mediaLoaded(e);
                    }.bind(this)
                  )
                  .on(
                    "shopify_model_viewer_ui_toggle_pause",
                    function (e) {
                      this.mediaUnloaded(e);
                    }.bind(this)
                  );
            },
            mediaLoaded: function (e) {
              this.$container
                .find(this.selectors.closeMedia)
                .removeClass("hide"),
                this.toggleSliderSwiping(!1);
            },
            mediaUnloaded: function (e) {
              this.$container.find(this.selectors.closeMedia).addClass("hide"),
                this.toggleSliderSwiping(!0);
            },
            toggleSliderSwiping: function (e) {
              this.$mainSlider &&
                this.settings.slickMainInitialized &&
                (this.$mainSlider.slick("slickSetOption", "swipe", e),
                this.$mainSlider.slick("slickSetOption", "draggable", e),
                this.$mainSlider.slick("slickSetOption", "touchMove", e),
                this.$mainSlider.slick("slickSetOption", "accessibility", e));
            },
            onUnload: function () {
              this.$container.off(this.settings.namespace),
                e("body").off(this.settings.namespace),
                this.destroyImageCarousels(),
                theme.ProductMedia.removeSectionModels(this.sectionId);
            },
          })),
          l
        );
      })()),
      (theme.Recommendations = (function () {
        function t(t) {
          var i = (this.$container = e(t)),
            n = (this.sectionId = i.attr("data-section-id"));
          (this.url = i.data("url")),
            (this.selectors = {
              recommendations: "#Recommendations-" + n,
              placeholder: ".product-recommendations-placeholder",
              sectionClass: " .product-recommendations",
              productResults: ".grid-product",
            }),
            this.init();
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              var t = e(this.selectors.recommendations);
              if (t.length && t.data("enable") !== !1) {
                var i = t.find(this.selectors.placeholder),
                  n = t.data("product-id"),
                  o = t.data("limit"),
                  a =
                    this.url +
                    "?section_id=product-recommendations&limit=" +
                    o +
                    "&product_id=" +
                    n;
                i.load(
                  a + this.selectors.sectionClass,
                  function (i) {
                    theme.reinitProductGridItem(t),
                      this.updateVariantInventory(t),
                      0 ===
                        e(i)
                          .find(this.selectors.sectionClass)
                          .find(this.selectors.productResults).length &&
                        t.addClass("hide");
                  }.bind(this)
                );
              }
            },
            updateVariantInventory: function (t) {
              (window.inventories = window.inventories || {}),
                t.find(".js-product-inventory-data").each(function () {
                  var t = e(this),
                    i = t.data("section-id");
                  (window.inventories[i] = {}),
                    e(".js-variant-inventory-data", t).each(function () {
                      var t = e(this);
                      window.inventories[i][t.data("id")] = {
                        quantity: t.data("quantity"),
                        incoming: t.data("incoming"),
                        next_incoming_date: t.data("date"),
                      };
                    });
                });
            },
          })),
          t
        );
      })()),
      (theme.CollectionHeader = (function () {
        function t(t) {
          var n = e(t);
          this.namespace = ".collection-header";
          var o = (this.$heroContainer = n.find(i.hero));
          if (o.length) {
            if ((this.checkIfNeedReload(), n.data("parallax"))) {
              var a = n.find(i.parallaxContainer),
                s = { namespace: this.namespace };
              theme.parallaxSections[this.namespace] = new theme.Parallax(a, s);
            }
          } else theme.headerNav.disableOverlayHeader();
        }
        var i = {
          hero: ".collection-hero",
          parallaxContainer: ".parallax-container",
        };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            checkIfNeedReload: function () {
              if (Shopify.designMode && theme.settings.overlayHeader) {
                var t = e(".header-wrapper");
                t.hasClass("is-light") ||
                  e(".header-wrapper").hasClass("header-wrapper--sticky") ||
                  location.reload();
              }
            },
            onUnload: function () {
              theme.parallaxSections[this.namespace] &&
                (theme.parallaxSections[this.namespace].destroy(),
                delete theme.parallaxSections[this.namespace]);
            },
          })),
          t
        );
      })()),
      (theme.CollectionSidebar = (function () {
        function t(t) {
          (this.$container = e(t)), this.init();
        }
        var i = !1;
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              this.onUnload(),
                (i = "drawer" === this.$container.data("style")),
                (theme.FilterDrawer = new theme.Drawers(
                  "FilterDrawer",
                  "collection-filters",
                  !0
                ));
            },
            forceReload: function () {
              this.init();
            },
            onSelect: function () {
              if (theme.FilterDrawer) {
                if (!i) return void theme.FilterDrawer.close();
                (i || theme.config.bpSmall) && theme.FilterDrawer.open();
              }
            },
            onDeselect: function () {
              theme.FilterDrawer && theme.FilterDrawer.close();
            },
            onUnload: function () {
              theme.FilterDrawer && theme.FilterDrawer.close();
            },
          })),
          t
        );
      })()),
      (theme.Collection = (function () {
        function t(t) {
          (this.container = t),
            (this.sectionId = e(t).attr("data-section-id")),
            (this.namespace = ".collection-" + this.sectionId),
            this.init();
        }
        var i = {
            colorSwatchImage: ".grid-product__color-image",
            colorSwatch: ".color-swatch--with-image",
            sortSelect: "#SortBy",
          },
          n = { sortBy: "data-default-sortby" };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              this.$container = e(this.container);
              var t = (this.sectionId =
                this.$container.attr("data-section-id"));
              (this.namespace = ".collection-" + t),
                (this.$sortSelect = e(i.sortSelect)),
                this.$sortSelect.on("change", this.onSortChange.bind(this)),
                (this.defaultSort = this.getDefaultSortValue()),
                this.initParams(),
                this.colorSwatchHovering(),
                theme.reinitSection("collection-sidebar");
            },
            initParams: function () {
              if (((this.queryParams = {}), location.search.length))
                for (
                  var e, t = location.search.substr(1).split("&"), i = 0;
                  i < t.length;
                  i++
                )
                  (e = t[i].split("=")),
                    e.length > 1 &&
                      (this.queryParams[decodeURIComponent(e[0])] =
                        decodeURIComponent(e[1]));
            },
            getSortValue: function () {
              return this.$sortSelect.val() || this.defaultSort;
            },
            getDefaultSortValue: function () {
              return this.$sortSelect.attr(n.sortBy);
            },
            onSortChange: function () {
              (this.queryParams.sort_by = this.getSortValue()),
                this.queryParams.page && delete this.queryParams.page,
                (window.location.search = e.param(this.queryParams));
            },
            colorSwatchHovering: function () {
              var t = e(i.colorSwatchImage);
              t.length &&
                e(i.colorSwatch).on({
                  mouseenter: function (t) {
                    $el = e(t.currentTarget);
                    var i = $el.data("variant-id"),
                      n = $el.data("variant-image");
                    e(".grid-product__color-image--" + i)
                      .css("background-image", "url(" + n + ")")
                      .addClass("is-active");
                  },
                  mouseleave: function (t) {
                    $el = e(t.currentTarget);
                    var i = $el.data("variant-id");
                    e(".grid-product__color-image--" + i).removeClass(
                      "is-active"
                    );
                  },
                });
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              e(window).off(this.namespace),
                this.$container.off(this.namespace),
                e(i.colorSwatch).off(this.namespace);
            },
          })),
          t
        );
      })()),
      (theme.HeaderSection = (function () {
        function t(t) {
          var i = (this.$container = e(t));
          this.sectionId = i.attr("data-section-id");
          theme.reinitSection("slideshow-section"),
            this.initDrawers(),
            theme.headerNav.init(),
            theme.announcementBar.init(),
            (this.cache = {}),
            this.cacheSelectors(),
            this.cache.$localeDisclosure.length &&
              (this.localeDisclosure = new theme.Disclosure(
                this.cache.$localeDisclosure
              )),
            this.cache.$currencyDisclosure.length &&
              (this.currencyDisclosure = new theme.Disclosure(
                this.cache.$currencyDisclosure
              )),
            Shopify.designMode &&
              setTimeout(function () {
                e("body").trigger("resize");
              }, 500);
        }
        var i = {
            drawer: "#NavDrawer",
            mobileSubNavToggle: ".mobile-nav__toggle-btn",
            hasSublist: ".mobile-nav__has-sublist",
            disclosureLocale: "[data-disclosure-locale]",
            disclosureCurrency: "[data-disclosure-currency]",
          },
          n = { navExpanded: "mobile-nav--expanded" };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            cacheSelectors: function () {
              this.cache = {
                $localeDisclosure: this.$container.find(i.disclosureLocale),
                $currencyDisclosure: this.$container.find(i.disclosureCurrency),
              };
            },
            initDrawers: function () {
              (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")),
                "drawer" === theme.settings.cartType && new theme.CartDrawer(),
                this.drawerMenuButtons();
            },
            drawerMenuButtons: function () {
              e(i.drawer)
                .find(".js-drawer-close")
                .on("click", function (e) {
                  e.preventDefault(), theme.NavDrawer.close();
                });
              var t = e(i.mobileSubNavToggle);
              t.attr("aria-expanded", "false"),
                t.each(function (t, i) {
                  var n = e(i);
                  n.attr("aria-controls", n.attr("data-aria-controls"));
                }),
                t.on("click", function () {
                  var t = e(this),
                    o = t.attr("aria-expanded"),
                    a = !1;
                  "true" === o
                    ? t.attr("aria-expanded", "false")
                    : (t.attr("aria-expanded", "true"), (a = !0)),
                    t.closest(i.hasSublist).toggleClass(n.navExpanded, a);
                });
            },
            onBlockSelect: function (e) {
              theme.announcementBar.onBlockSelect(e.detail.blockId);
            },
            onDeselect: function () {
              theme.announcementBar.onBlockDeselect();
            },
            onUnload: function () {
              theme.NavDrawer.close(),
                theme.headerNav.unload(),
                theme.announcementBar.unload(),
                this.cache.$localeDisclosure.length &&
                  this.localeDisclosure.unload(),
                this.cache.$currencyDisclosure.length &&
                  this.currencyDisclosure.unload();
            },
          })),
          t
        );
      })()),
      (theme.FooterSection = (function () {
        function t(t) {
          this.$container = e(t);
          (this.cache = {}),
            this.cacheSelectors(),
            this.cache.$localeDisclosure.length &&
              (this.localeDisclosure = new theme.Disclosure(
                this.cache.$localeDisclosure
              )),
            this.cache.$currencyDisclosure.length &&
              (this.currencyDisclosure = new theme.Disclosure(
                this.cache.$currencyDisclosure
              ));
        }
        var i = {
          disclosureLocale: "[data-disclosure-locale]",
          disclosureCurrency: "[data-disclosure-currency]",
        };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            cacheSelectors: function () {
              this.cache = {
                $localeDisclosure: this.$container.find(i.disclosureLocale),
                $currencyDisclosure: this.$container.find(i.disclosureCurrency),
              };
            },
            onUnload: function () {
              this.cache.$localeDisclosure.length &&
                this.localeDisclosure.unload(),
                this.cache.$currencyDisclosure.length &&
                  this.currencyDisclosure.unload();
            },
          })),
          t
        );
      })()),
      (theme.FeaturedContentSection = (function () {
        function t() {
          e(".rte").find("a:not(:has(img))").addClass("text-link");
        }
        return t;
      })()),
      (theme.slideshows = {}),
      (theme.SlideshowSection = (function () {
        function t(t) {
          var n = (this.$container = e(t)),
            o = (n.parent(), n.attr("data-section-id"));
          this.slideshow = "#Slideshow-" + o;
          this.namespace = "." + o;
          var a = e(t).find(".hero");
          if (
            (a.length && theme.loadImageSection(a),
            this.init(),
            n.data("parallax"))
          ) {
            var s = { namespace: this.namespace };
            theme.parallaxSections[this.namespace] = new theme.Parallax(
              n.find(i.parallaxContainer),
              s
            );
          }
        }
        var i = { parallaxContainer: ".parallax-container" };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              this.onUnload();
              var t = e(this.slideshow),
                i = {
                  autoplay: t.data("autoplay"),
                  arrows: t.data("arrows"),
                  dots: t.data("dots"),
                  fade: !0,
                  speed: 500,
                };
              theme.slideshows[this.slideshow] = new theme.Slideshow(
                this.slideshow,
                i
              );
            },
            forceReload: function () {
              this.init();
            },
            onUnload: function () {
              theme.parallaxSections[this.namespace] &&
                (theme.parallaxSections[this.namespace].destroy(),
                delete theme.parallaxSections[this.namespace]),
                theme.slideshows[this.slideshow] &&
                  (theme.slideshows[this.slideshow].destroy(),
                  delete theme.slideshows[this.slideshow]);
            },
            onSelect: function () {
              e(this.slideshow).slick("slickPause");
            },
            onDeselect: function () {
              e(this.slideshow).slick("slickPlay");
            },
            onBlockSelect: function (t) {
              var i = e(this.slideshow),
                n = e(
                  ".slideshow__slide--" +
                    t.detail.blockId +
                    ":not(.slick-cloned)"
                ),
                o = n.data("slick-index");
              i.slick("slickGoTo", o).slick("slickPause");
            },
            onBlockDeselect: function () {
              e(this.slideshow).slick("slickPlay");
            },
          })),
          t
        );
      })()),
      (theme.VideoSection = (function () {
        function t(t) {
          var n = (this.$container = e(t)),
            o =
              ((this.sectionId = n.attr("data-section-id")),
              (this.youtubePlayerId = "YouTubeVideo-" + this.sectionId));
          this.namespace = "." + o;
          var a = (this.vimeoPlayerId = "Vimeo-" + this.sectionId),
            s =
              ((this.$vimeoTrigger = e("#VimeoTrigger-" + this.sectionId)),
              "Mp4Video-" + this.sectionId),
            r = e("#" + o),
            c = e("#" + a),
            h = e("#" + s);
          (this.vimeoPlayer = []),
            r.length &&
              ((this.youtubeVideoId = r.data("video-id")),
              this.initYoutubeVideo()),
            c.length &&
              ((this.vimeoVideoId = c.data("video-id")), this.initVimeoVideo()),
            h.length &&
              (d(h),
              i(s)
                .then(function () {})
                .catch(function (e) {
                  h.attr("controls", ""), l(h);
                }));
        }
        function i(e) {
          return document.querySelector("#" + e).play();
        }
        function n(t, i) {
          var n = e("#" + i),
            a = n.attr("id");
          p[a] = t.target;
          p[a];
          c(n),
            p[a].mute(),
            n.attr("tabindex", "-1"),
            o(a),
            e(window).on("scroll." + a, { id: a }, e.throttle(150, o));
        }
        function o(t) {
          var i;
          (i = "string" == typeof t ? t : !!t.data && t.data.id),
            i && (theme.isElementVisible(e("#" + i)) ? a(i) : s(i));
        }
        function a(e) {
          p[e] && "function" == typeof p[e].playVideo && p[e].playVideo();
        }
        function s(e) {
          p[e] && "function" == typeof p[e].pauseVideo && p[e].pauseVideo();
        }
        function r(t, i) {
          var n = e("#" + i),
            o = n.attr("id"),
            a = p[o];
          switch (t.data) {
            case -1:
              u[o].attemptedToPlay && (d(n), l(n));
              break;
            case 0:
              a.playVideo();
              break;
            case 1:
              d(n);
              break;
            case 3:
              u[o].attemptedToPlay = !0;
          }
        }
        function c(e) {
          e.closest(v.videoParent).addClass(y.loading);
        }
        function d(e) {
          e.closest(v.videoParent).removeClass(y.loading).addClass(y.loaded);
        }
        function l(e) {
          e.closest(v.videoParent).addClass(y.interactable),
            e.closest(v.promoContainer).addClass(y.interactable);
        }
        var h,
          u = [],
          p = [],
          m = {
            width: 1280,
            height: 720,
            playerVars: {
              autohide: 0,
              branding: 0,
              cc_load_policy: 0,
              controls: 0,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              quality: "hd720",
              rel: 0,
              showinfo: 0,
              wmode: "opaque",
            },
          },
          f = !1,
          g = { byline: !1, title: !1, portrait: !1, loop: !0 },
          v = {
            videoParent: ".video-parent-section",
            promoContainer: ".promo-grid__container",
          },
          y = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable",
          };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            initYoutubeVideo: function () {
              (u[this.youtubePlayerId] = {
                id: this.youtubePlayerId,
                videoId: this.youtubeVideoId,
                type: "youtube",
                attemptedToPlay: !1,
                events: {
                  onReady: function (e) {
                    n(e, this.youtubePlayerId);
                  }.bind(this),
                  onStateChange: function (e) {
                    r(e, this.youtubePlayerId);
                  }.bind(this),
                },
              }),
                h
                  ? this.loadYoutubeVideo()
                  : (theme.LibraryLoader.load("youtubeSdk"),
                    e("body").on(
                      "youTubeReady" + this.namespace,
                      this.loadYoutubeVideo.bind(this)
                    ));
            },
            loadYoutubeVideo: function () {
              var t = e.extend({}, m, u[this.youtubePlayerId]);
              (t.playerVars.controls = 0),
                (p[this.youtubePlayerId] = new YT.Player(
                  this.youtubePlayerId,
                  t
                )),
                (h = !0);
            },
            initVimeoVideo: function () {
              u[this.vimeoPlayerId] = {
                divId: this.vimeoPlayerId,
                id: this.vimeoVideoId,
                type: "vimeo",
              };
              var t = e("#" + this.vimeoPlayerId);
              c(t),
                this.$vimeoTrigger.on(
                  "click",
                  +this.namespace,
                  function (e) {
                    this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                  }.bind(this)
                ),
                f
                  ? this.loadVimeoVideo()
                  : (window.loadVimeo(),
                    e("body").on(
                      "vimeoReady" + this.namespace,
                      this.loadVimeoVideo.bind(this)
                    ));
            },
            loadVimeoVideo: function () {
              var t = e.extend({}, g, u[this.vimeoPlayerId]);
              if (
                ((this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(
                  u[this.vimeoPlayerId].divId,
                  t
                )),
                (f = !0),
                theme.config.bpSmall)
              ) {
                var i = e("#" + this.vimeoPlayerId);
                d(i);
              } else this.requestToPlayVimeoVideo(this.vimeoPlayerId);
            },
            requestToPlayVimeoVideo: function (t) {
              return f
                ? void this.playVimeoVideo(t)
                : void e("body").on(
                    "vimeoReady" + this.namespace,
                    function () {
                      this.playVimeoVideo(t);
                    }.bind(this)
                  );
            },
            playVimeoVideo: function (t) {
              this.vimeoPlayer[t].play(), this.vimeoPlayer[t].setVolume(0);
              var i = e("#" + t);
              d(i);
            },
            onUnload: function (t) {
              var i = t.target.id.replace("shopify-section-", ""),
                n = "YouTubeVideo-" + i;
              p[n].destroy(),
                e(window).off("scroll" + this.namespace),
                e("body").off("vimeoReady" + this.namespace);
            },
          })),
          t
        );
      })()),
      (theme.BackgroundImage = (function () {
        function t(t) {
          var n = e(t),
            o = n.attr("data-section-id");
          if (((this.namespace = "." + o), n.length && n.data("parallax"))) {
            var a = n.find(i.parallaxContainer),
              s = { namespace: this.namespace, desktopOnly: !0 };
            theme.parallaxSections[this.namespace] = new theme.Parallax(a, s);
          }
        }
        var i = { parallaxContainer: ".parallax-container" };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            onUnload: function (e) {
              theme.parallaxSections[this.namespace].destroy(),
                delete theme.parallaxSections[this.namespace];
            },
          })),
          t
        );
      })()),
      (theme.Testimonials = (function () {
        function t(t) {
          var o = (this.$container = e(t)),
            a = o.attr("data-section-id"),
            s =
              ((this.wrapper = ".testimonials-wrapper"),
              (this.slider = "#Testimonials-" + a)),
            r = e(s);
          this.sliderActive = !1;
          var c = e.extend({}, n, {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: !0,
          });
          (i = r.data("count")),
            i < n.slidesToShow &&
              ((n.slidesToShow = i), (n.slidesToScroll = i)),
            r.on("init", this.a11y.bind(this)),
            theme.config.bpSmall ? this.init(r, c) : this.init(r, n),
            e("body").on(
              "matchSmall",
              function () {
                this.init(r, c);
              }.bind(this)
            ),
            e("body").on(
              "matchLarge",
              function () {
                this.init(r, n);
              }.bind(this)
            );
        }
        var i = 0,
          n = {
            accessibility: !0,
            arrows: !1,
            dots: !0,
            autoplay: !1,
            touchThreshold: 20,
            slidesToShow: 3,
            slidesToScroll: 3,
          };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            onUnload: function () {
              e(this.slider, this.wrapper).slick("unslick");
            },
            onBlockSelect: function (t) {
              var i = e(
                  ".testimonials-slide--" +
                    t.detail.blockId +
                    ":not(.slick-cloned)"
                ),
                n = i.data("slick-index");
              e(this.slider, this.wrapper).slick("slickGoTo", n);
            },
            init: function (e, t) {
              this.sliderActive &&
                (e.slick("unslick"), (this.sliderActive = !1)),
                e.slick(t),
                (this.sliderActive = !0),
                AOS && AOS.refresh();
            },
            a11y: function (t, i) {
              var n = i.$list,
                o = e(this.wrapper, this.$container);
              n.removeAttr("aria-live"),
                o.on("focusin", function (e) {
                  o.has(e.target).length && n.attr("aria-live", "polite");
                }),
                o.on("focusout", function (e) {
                  o.has(e.target).length && n.removeAttr("aria-live");
                });
            },
          })),
          t
        );
      })()),
      (theme.NewsletterPopup = (function () {
        function t(t) {
          var i = (this.$container = e(t)),
            n = i.attr("data-section-id");
          if (
            ((this.cookieName = "newsletter-" + n),
            i.length && "/challenge" !== window.location.pathname)
          ) {
            if (
              ((this.data = {
                secondsBeforeShow: i.data("delay-seconds"),
                daysBeforeReappear: i.data("delay-days"),
                cookie: Cookies.get(this.cookieName),
                testMode: i.data("test-mode"),
              }),
              (this.modal = new theme.Modals(
                "NewsletterPopup-" + n,
                "newsletter-popup-modal"
              )),
              (i.find(".errors").length || i.find(".note--success").length) &&
                this.modal.open(),
              i.find(".note--success").length)
            )
              return void this.closePopup(!0);
            e("body").on(
              "modalClose." + i.attr("id"),
              this.closePopup.bind(this)
            ),
              (this.data.cookie && !this.data.testMode) ||
                this.initPopupDelay();
          }
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            initPopupDelay: function () {
              setTimeout(
                function () {
                  this.modal.open();
                }.bind(this),
                1e3 * this.data.secondsBeforeShow
              );
            },
            closePopup: function (e) {
              if (this.data.testMode)
                return void Cookies.remove(this.cookieName, { path: "/" });
              var t = e ? 200 : this.data.daysBeforeReappear;
              Cookies.set(this.cookieName, "opened", { path: "/", expires: t });
            },
            onLoad: function () {
              this.modal.open();
            },
            onSelect: function () {
              this.modal.open();
            },
            onDeselect: function () {
              this.modal.close();
            },
            onUnload: function () {},
          })),
          t
        );
      })()),
      (theme.Maps = (function () {
        function t(t) {
          (this.$container = e(t)),
            (this.sectionId = this.$container.attr("data-section-id")),
            (this.namespace = ".map-" + this.sectionId),
            (this.$map = this.$container.find(c.map)),
            (this.key = this.$map.data("api-key")),
            this.key &&
              (this.checkVisibility(),
              e(window).on(
                "scroll" + this.namespace,
                e.throttle(50, this.checkVisibility.bind(this))
              ));
        }
        function i() {
          e.each(s, function (e, t) {
            t.createMap();
          });
        }
        function n(t) {
          var i = e.Deferred(),
            n = new google.maps.Geocoder(),
            o = t.data("address-setting");
          return (
            n.geocode({ address: o }, function (e, t) {
              t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e);
            }),
            i
          );
        }
        var o = { zoom: 14 },
          a = null,
          s = [],
          r = {
            addressNoResults: theme.strings.addressNoResults,
            addressQueryLimit: theme.strings.addressQueryLimit,
            addressError: theme.strings.addressError,
            authError: theme.strings.authError,
          },
          c = {
            section: '[data-section-type="map"]',
            map: "[data-map]",
            mapOverlay: "[data-map-overlay]",
          },
          d = {
            mapError: "map-section--load-error",
            errorMsg: "map-section__error errors text-center",
          };
        return (
          (window.gm_authFailure = function () {
            Shopify.designMode &&
              (e(c.section).addClass(d.mapError),
              e(c.map).remove(),
              e(c.mapOverlay).after(
                '<div class="' +
                  d.errorMsg +
                  '">' +
                  theme.strings.authError +
                  "</div>"
              ));
          }),
          (t.prototype = e.extend({}, t.prototype, {
            prepMapApi: function () {
              "loaded" === a
                ? this.createMap()
                : (s.push(this),
                  "loading" !== a &&
                    ((a = "loading"),
                    ("undefined" != typeof window.google &&
                      "undefined" != typeof window.google.maps) ||
                      e
                        .getScript(
                          "https://maps.googleapis.com/maps/api/js?key=" +
                            this.key
                        )
                        .then(function () {
                          (a = "loaded"), i();
                        })));
            },
            createMap: function () {
              var t = this.$map;
              return n(t)
                .then(
                  function (i) {
                    var n = {
                        zoom: o.zoom,
                        backgroundColor: "none",
                        center: i[0].geometry.location,
                        draggable: !1,
                        clickableIcons: !1,
                        scrollwheel: !1,
                        disableDoubleClickZoom: !0,
                        disableDefaultUI: !0,
                      },
                      a = (this.map = new google.maps.Map(t[0], n)),
                      s = (this.center = a.getCenter());
                    new google.maps.Marker({ map: a, position: a.getCenter() });
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      e.debounce(250, function () {
                        google.maps.event.trigger(a, "resize"),
                          a.setCenter(s),
                          t.removeAttr("style");
                      })
                    );
                  }.bind(this)
                )
                .fail(function () {
                  var e;
                  switch (status) {
                    case "ZERO_RESULTS":
                      e = r.addressNoResults;
                      break;
                    case "OVER_QUERY_LIMIT":
                      e = r.addressQueryLimit;
                      break;
                    case "REQUEST_DENIED":
                      e = r.authError;
                      break;
                    default:
                      e = r.addressError;
                  }
                  Shopify.designMode &&
                    t
                      .parent()
                      .addClass(d.mapError)
                      .html('<div class="' + d.errorMsg + '">' + e + "</div>");
                });
            },
            checkVisibility: function () {
              theme.isElementVisible(this.$container, 600) &&
                (this.prepMapApi(), e(window).off(this.namespace));
            },
            onUnload: function () {
              0 !== this.$map.length &&
                google.maps.event.clearListeners(this.map, "resize");
            },
          })),
          t
        );
      })()),
      (theme.Blog = (function () {
        function t(e) {
          this.tagFilters();
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            tagFilters: function () {
              var t = e("#BlogTagFilter");
              t.length &&
                t.on("change", function () {
                  location.href = e(this).val();
                });
            },
            onUnload: function () {},
          })),
          t
        );
      })()),
      (theme.Photoswipe = (function () {
        function t(t, i) {
          (this.$container = e(t)),
            (this.sectionId = i),
            (this.namespace = ".photoswipe-" + this.sectionId),
            this.gallery,
            this.$images,
            (this.inSlideshow = !1),
            "false" !== this.$container.attr("data-zoom") &&
              ("true" === this.$container.attr("data-has-slideshow") &&
                (this.inSlideshow = !0),
              this.init());
        }
        var i = {
          trigger: ".js-photoswipe__zoom",
          images: ".photoswipe__image",
          activeImage: ".slick-active .photoswipe__image",
        };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              var t = this.$container.find(i.trigger);
              this.$images = this.$container.find(i.images);
              var n = [];
              t.on(
                "click" + this.namespace,
                function (t) {
                  if (((n = this.getImageData()), this.inSlideshow))
                    var o = this.$container.find(i.activeImage).data("index");
                  else var o = e(t.currentTarget).data("index");
                  this.initGallery(n, o);
                }.bind(this)
              );
            },
            getImageData: function () {
              var t = [];
              return (
                this.$images.each(function () {
                  var i = e(this).prop("currentSrc") || e(this).prop("src"),
                    n = {
                      msrc: i,
                      src: e(this).data("photoswipe-src"),
                      w: e(this).data("photoswipe-width"),
                      h: e(this).data("photoswipe-height"),
                      el: e(this)[0],
                      initialZoomLevel: 0.5,
                    };
                  t.push(n);
                }),
                t
              );
            },
            initGallery: function (e, t) {
              var i = document.querySelectorAll(".pswp")[0],
                n = {
                  allowPanToNext: !1,
                  captionEl: !1,
                  closeOnScroll: !1,
                  counterEl: !1,
                  history: !1,
                  index: t - 1,
                  pinchToClose: !1,
                  preloaderEl: !1,
                  scaleMode: "zoom",
                  shareEl: !1,
                  tapToToggleControls: !1,
                  getThumbBoundsFn: function (t) {
                    var i =
                        window.pageYOffset ||
                        document.documentElement.scrollTop,
                      n = e[t].el,
                      o = n.getBoundingClientRect();
                    return { x: o.left, y: o.top + i, w: o.width };
                  },
                };
              (this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, e, n)),
                this.gallery.init(),
                this.gallery.listen("afterChange", this.afterChange.bind(this));
            },
            afterChange: function () {
              if (this.inSlideshow) {
                var t = e("#ProductPhotos-" + this.sectionId);
                if (t.hasClass("slick-initialized")) {
                  var i = this.gallery.getCurrentIndex();
                  t.slick("slickGoTo", i);
                }
              }
            },
          })),
          t
        );
      })()),
      (theme.bp = {}),
      (theme.bp.smallUp = 769),
      (theme.bp.small = theme.bp.smallUp - 1),
      (theme.config = {
        bpSmall: !1,
        hasSessionStorage: !0,
        hasLocalStorage: !0,
        mediaQuerySmall: "screen and (max-width: " + theme.bp.small + "px)",
        mediaQuerySmallUp: "screen and (min-width: " + theme.bp.smallUp + "px)",
        youTubeReady: !1,
        vimeoReady: !1,
        vimeoLoading: !1,
        isTouch: !!(
          "ontouchstart" in window ||
          (window.DocumentTouch && window.document instanceof DocumentTouch) ||
          window.navigator.maxTouchPoints ||
          window.navigator.msMaxTouchPoints
        ),
        isIpad:
          /ipad/.test(window.navigator.userAgent.toLowerCase()) ||
          ("MacIntel" === window.navigator.platform &&
            window.navigator.maxTouchPoints > 1),
        stickyHeader: !1,
        recentlyViewed: [],
      }),
      theme.config.isIpad && (document.documentElement.className += " js-ipad"),
      (theme.recentlyViewed = { recent: {}, productInfo: {} }),
      (window.onYouTubeIframeAPIReady = function () {
        (theme.config.youTubeReady = !0), e("body").trigger("youTubeReady");
      }),
      (window.loadVimeo = function () {
        if (!theme.config.vimeoLoading && !theme.config.vimeoReady) {
          theme.config.vimeoLoading = !0;
          var i = document.createElement("script");
          i.src = "https://player.vimeo.com/api/player.js";
          var n = document.getElementsByTagName("script")[0];
          n.parentNode.insertBefore(i, n),
            t()
              .then(function () {
                (theme.config.vimeoReady = !0),
                  (theme.config.vimeoLoading = !1),
                  e("body").trigger("vimeoReady");
              })
              .fail(function () {});
        }
      }),
      (theme.init = function () {
        theme.setGlobals(),
          theme.collapsibles.init(),
          theme.rte.init(),
          AOS.init({
            easing: "ease-out-quad",
            once: !0,
            offset: 60,
            disableMutationObserver: !0,
          }),
          e(document.documentElement).on("keyup.tab", function (t) {
            9 === t.keyCode &&
              (e(document.documentElement).addClass("tab-outline"),
              e(document.documentElement).off("keyup.tab"));
          }),
          e(".footer__newsletter-input").on("keyup", function () {
            e(this).addClass("footer__newsletter-input--active");
          });
      }),
      (theme.initSecondary = function () {
        theme.initQuickShop(),
          theme.settings.predictiveSearch && theme.predictiveSearch.init(),
          theme.collectionTemplate.init(),
          theme.customerTemplates.init(),
          theme.videoModal(),
          document.dispatchEvent(new CustomEvent("page:loaded"));
      }),
      (theme.setGlobals = function () {
        (theme.config.hasSessionStorage = theme.isStorageSupported("session")),
          (theme.config.hasLocalStorage = theme.isStorageSupported("local")),
          theme.config.hasLocalStorage &&
            ((theme.recentlyViewed.localStorage =
              window.localStorage.getItem("theme-recent")),
            theme.recentlyViewed.localStorage &&
              (theme.recentlyViewed.recent = JSON.parse(
                theme.recentlyViewed.localStorage
              ))),
          (theme.recentlyViewed.productInfo =
            theme.config.hasSessionStorage && sessionStorage["recent-products"]
              ? JSON.parse(sessionStorage["recent-products"])
              : {}),
          theme.config.isTouch && e("body").addClass("supports-touch"),
          enquire.register(theme.config.mediaQuerySmall, {
            match: function () {
              (theme.config.bpSmall = !0), e("body").trigger("matchSmall");
            },
            unmatch: function () {
              (theme.config.bpSmall = !1), e("body").trigger("unmatchSmall");
            },
          }),
          enquire.register(theme.config.mediaQuerySmallUp, {
            match: function () {
              e("body").trigger("matchLarge");
            },
            unmatch: function () {
              e("body").trigger("unmatchLarge");
            },
          });
      }),
      (theme.loadImageSection = function (e) {
        function t() {
          e.removeClass("loading loading--delayed").addClass("loaded");
        }
        function i() {
          return e.find(".lazyloaded").length;
        }
        if (e.find("svg").length) return void t();
        if (i() > 0) return void t();
        var n = setInterval(function () {
          i() > 0 && (clearInterval(n), t());
        }, 80);
      }),
      (theme.isStorageSupported = function (e) {
        if (window.self !== window.top) return !1;
        var t,
          i = "test";
        "session" === e && (t = window.sessionStorage),
          "local" === e && (t = window.localStorage);
        try {
          return t.setItem(i, "1"), t.removeItem(i), !0;
        } catch (e) {
          return !1;
        }
      }),
      (theme.isElementVisible = function (e, t) {
        var i = e[0].getBoundingClientRect(),
          n = window.innerHeight || document.documentElement.clientHeight;
        return (
          (t = t ? t : 0),
          i.bottom >= 0 &&
            i.right >= 0 &&
            i.top <= n + t &&
            i.left <=
              (window.innerWidth || document.documentElement.clientWidth)
        );
      }),
      (theme.reinitSection = function (e) {
        for (var t = 0; t < sections.instances.length; t++) {
          var i = sections.instances[t];
          i.type === e && "function" == typeof i.forceReload && i.forceReload();
        }
      }),
      (theme.reinitProductGridItem = function (e) {
        AOS && AOS.refreshHard(),
          theme.initQuickShop(),
          window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
          sections.register("product-template", theme.Product, e),
          theme.collapsibles.init();
      }),
      (window.onpageshow = function (t) {
        t.persisted && e("body").removeClass("unloading");
      }),
      e(document).ready(function () {
        theme.init(),
          (window.sections = new theme.Sections()),
          sections.register("header-section", theme.HeaderSection),
          sections.register("slideshow-section", theme.SlideshowSection),
          sections.register("video-section", theme.VideoSection),
          sections.register("background-image", theme.BackgroundImage),
          sections.register("recently-viewed", theme.RecentlyViewed),
          sections.register("product", theme.Product),
          sections.register("product-recommendations", theme.Recommendations),
          sections.register("product-template", theme.Product),
          sections.register("collection-header", theme.CollectionHeader),
          sections.register("collection-sidebar", theme.CollectionSidebar),
          sections.register("collection-template", theme.Collection),
          sections.register(
            "featured-content-section",
            theme.FeaturedContentSection
          ),
          sections.register("testimonials", theme.Testimonials),
          sections.register("newsletter-popup", theme.NewsletterPopup),
          sections.register("map", theme.Maps),
          sections.register("blog", theme.Blog),
          sections.register("photoswipe", theme.Photoswipe),
          sections.register("footer-section", theme.FooterSection),
          theme.initSecondary();
      });
  })(theme.jQuery);
